import { jsx as a, jsxs as b, Fragment as ma } from "react/jsx-runtime";
import Ie, { useContext as ye, useEffect as M, createContext as Ve, useRef as F, useState as X, forwardRef as ha, useImperativeHandle as va, useCallback as j, useMemo as ke, Children as Fe, isValidElement as Ze, lazy as Ga, createElement as Ya, cloneElement as ga, Fragment as De } from "react";
import Y from "clsx";
import { assignInlineVars as V } from "@vanilla-extract/dynamic";
import { createRuntimeFn as w } from "@vanilla-extract/recipes/createRuntimeFn";
import { fallbackVar as Ja } from "@vanilla-extract/css";
import { createSprinkles as Ka } from "@vanilla-extract/sprinkles/createRuntimeSprinkles";
import { PointerSensor as _a, useSensors as $a, useSensor as er, DndContext as ar, pointerWithin as rr, DragOverlay as tr, useDraggable as Ar, useDroppable as nr } from "@dnd-kit/core";
import { FloatingArrow as sr, useFloating as or, offset as lr, flip as ir, shift as dr, arrow as cr, autoUpdate as pr, useHover as ur, safePolygon as mr, useDismiss as hr, useRole as vr, useInteractions as gr } from "@floating-ui/react";
import './index.css';var Z = { colors: { main: { primary: "var(--sparta-components-colors-main-primary)", dark: "var(--sparta-components-colors-main-dark)", darker: "var(--sparta-components-colors-main-darker)", light: "var(--sparta-components-colors-main-light)" }, neutral: { dark_00: "var(--sparta-components-colors-neutral-dark_00)", dark_10: "var(--sparta-components-colors-neutral-dark_10)", dark_35: "var(--sparta-components-colors-neutral-dark_35)", dark_45: "var(--sparta-components-colors-neutral-dark_45)", dark_95: "var(--sparta-components-colors-neutral-dark_95)", dark_100: "var(--sparta-components-colors-neutral-dark_100)" }, neutral_blue: { dark_20: "var(--sparta-components-colors-neutral_blue-dark_20)", dark_35: "var(--sparta-components-colors-neutral_blue-dark_35)", dark_45: "var(--sparta-components-colors-neutral_blue-dark_45)", dark_70: "var(--sparta-components-colors-neutral_blue-dark_70)", dark_73: "var(--sparta-components-colors-neutral_blue-dark_73)", dark_75: "var(--sparta-components-colors-neutral_blue-dark_75)", dark_77: "var(--sparta-components-colors-neutral_blue-dark_77)", dark_79: "var(--sparta-components-colors-neutral_blue-dark_79)", dark_80: "var(--sparta-components-colors-neutral_blue-dark_80)", dark_82: "var(--sparta-components-colors-neutral_blue-dark_82)", dark_85: "var(--sparta-components-colors-neutral_blue-dark_85)", dark_87: "var(--sparta-components-colors-neutral_blue-dark_87)", dark_90: "var(--sparta-components-colors-neutral_blue-dark_90)", dark_95: "var(--sparta-components-colors-neutral_blue-dark_95)" }, blue_dark: { dark_01: "var(--sparta-components-colors-blue_dark-dark_01)", dark_02: "var(--sparta-components-colors-blue_dark-dark_02)", dark_03: "var(--sparta-components-colors-blue_dark-dark_03)", dark_04: "var(--sparta-components-colors-blue_dark-dark_04)", dark_05: "var(--sparta-components-colors-blue_dark-dark_05)" }, blue_light: { light_01: "var(--sparta-components-colors-blue_light-light_01)", light_02: "var(--sparta-components-colors-blue_light-light_02)", light_03: "var(--sparta-components-colors-blue_light-light_03)", light_04: "var(--sparta-components-colors-blue_light-light_04)", light_05: "var(--sparta-components-colors-blue_light-light_05)" }, feedback_success: { principal: "var(--sparta-components-colors-feedback_success-principal)", bright: "var(--sparta-components-colors-feedback_success-bright)", light: "var(--sparta-components-colors-feedback_success-light)", dark_01: "var(--sparta-components-colors-feedback_success-dark_01)", medium: "var(--sparta-components-colors-feedback_success-medium)", dark: "var(--sparta-components-colors-feedback_success-dark)", dark_02: "var(--sparta-components-colors-feedback_success-dark_02)", shaded: "var(--sparta-components-colors-feedback_success-shaded)", darker: "var(--sparta-components-colors-feedback_success-darker)" }, feedback_warning: { principal: "var(--sparta-components-colors-feedback_warning-principal)", light: "var(--sparta-components-colors-feedback_warning-light)", dark: "var(--sparta-components-colors-feedback_warning-dark)", darker: "var(--sparta-components-colors-feedback_warning-darker)" }, feedback_alert: { principal: "var(--sparta-components-colors-feedback_alert-principal)", light: "var(--sparta-components-colors-feedback_alert-light)", dark: "var(--sparta-components-colors-feedback_alert-dark)" }, feedback_error: { principal: "var(--sparta-components-colors-feedback_error-principal)", light: "var(--sparta-components-colors-feedback_error-light)", dark: "var(--sparta-components-colors-feedback_error-dark)", darker: "var(--sparta-components-colors-feedback_error-darker)" }, graph: { 1: { principal: "var(--sparta-components-colors-graph-1-principal)", light: "var(--sparta-components-colors-graph-1-light)", dark: "var(--sparta-components-colors-graph-1-dark)", greyish: "var(--sparta-components-colors-graph-1-greyish)", darker: "var(--sparta-components-colors-graph-1-darker)" }, 2: { principal: "var(--sparta-components-colors-graph-2-principal)", light: "var(--sparta-components-colors-graph-2-light)", dark: "var(--sparta-components-colors-graph-2-dark)", greyish: "var(--sparta-components-colors-graph-2-greyish)", darker: "var(--sparta-components-colors-graph-2-darker)" }, 3: { principal: "var(--sparta-components-colors-graph-3-principal)", light: "var(--sparta-components-colors-graph-3-light)", dark: "var(--sparta-components-colors-graph-3-dark)", greyish: "var(--sparta-components-colors-graph-3-greyish)", darker: "var(--sparta-components-colors-graph-3-darker)" }, 4: { principal: "var(--sparta-components-colors-graph-4-principal)", light: "var(--sparta-components-colors-graph-4-light)", dark: "var(--sparta-components-colors-graph-4-dark)", greyish: "var(--sparta-components-colors-graph-4-greyish)", darker: "var(--sparta-components-colors-graph-4-darker)" }, 5: { principal: "var(--sparta-components-colors-graph-5-principal)", light: "var(--sparta-components-colors-graph-5-light)", dark: "var(--sparta-components-colors-graph-5-dark)", greyish: "var(--sparta-components-colors-graph-5-greyish)", darker: "var(--sparta-components-colors-graph-5-darker)" }, 6: { principal: "var(--sparta-components-colors-graph-6-principal)", light: "var(--sparta-components-colors-graph-6-light)", dark: "var(--sparta-components-colors-graph-6-dark)", greyish: "var(--sparta-components-colors-graph-6-greyish)", darker: "var(--sparta-components-colors-graph-6-darker)" }, 7: { principal: "var(--sparta-components-colors-graph-7-principal)", light: "var(--sparta-components-colors-graph-7-light)", dark: "var(--sparta-components-colors-graph-7-dark)", greyish: "var(--sparta-components-colors-graph-7-greyish)", darker: "var(--sparta-components-colors-graph-7-darker)" }, 8: { principal: "var(--sparta-components-colors-graph-8-principal)", light: "var(--sparta-components-colors-graph-8-light)", dark: "var(--sparta-components-colors-graph-8-dark)", greyish: "var(--sparta-components-colors-graph-8-greyish)", darker: "var(--sparta-components-colors-graph-8-darker)" }, 9: { principal: "var(--sparta-components-colors-graph-9-principal)", light: "var(--sparta-components-colors-graph-9-light)", dark: "var(--sparta-components-colors-graph-9-dark)", greyish: "var(--sparta-components-colors-graph-9-greyish)", darker: "var(--sparta-components-colors-graph-9-darker)" }, 10: { principal: "var(--sparta-components-colors-graph-10-principal)", light: "var(--sparta-components-colors-graph-10-light)", dark: "var(--sparta-components-colors-graph-10-dark)", greyish: "var(--sparta-components-colors-graph-10-greyish)", darker: "var(--sparta-components-colors-graph-10-darker)" } }, heatmap: { 0: "var(--sparta-components-colors-heatmap-0)", 1: "var(--sparta-components-colors-heatmap-1)", 2: "var(--sparta-components-colors-heatmap-2)", 3: "var(--sparta-components-colors-heatmap-3)", 4: "var(--sparta-components-colors-heatmap-4)", 5: "var(--sparta-components-colors-heatmap-5)", 6: "var(--sparta-components-colors-heatmap-6)", 7: "var(--sparta-components-colors-heatmap-7)", 8: "var(--sparta-components-colors-heatmap-8)", 9: "var(--sparta-components-colors-heatmap-9)" }, menu_button: { main: "var(--sparta-components-colors-menu_button-main)", hover: "var(--sparta-components-colors-menu_button-hover)", disabled: "var(--sparta-components-colors-menu_button-disabled)" }, providers: { 1: "var(--sparta-components-colors-providers-1)", 2: "var(--sparta-components-colors-providers-2)", "1-hover": "var(--sparta-components-colors-providers-1-hover)", "2-hover": "var(--sparta-components-colors-providers-2-hover)" }, ios: { light: "var(--sparta-components-colors-ios-light)", dark: "var(--sparta-components-colors-ios-dark)", main_greyish: "var(--sparta-components-colors-ios-main_greyish)" } }, borders: { radius: { 2: "var(--sparta-components-borders-radius-2)", 4: "var(--sparta-components-borders-radius-4)", 6: "var(--sparta-components-borders-radius-6)", 8: "var(--sparta-components-borders-radius-8)", 10: "var(--sparta-components-borders-radius-10)" } }, typography: { family: "var(--sparta-components-typography-family)", weight: { bold: "var(--sparta-components-typography-weight-bold)", semibold: "var(--sparta-components-typography-weight-semibold)", regular: "var(--sparta-components-typography-weight-regular)" }, sizes: { h1: { fontSize: "var(--sparta-components-typography-sizes-h1-fontSize)", lineHeight: "var(--sparta-components-typography-sizes-h1-lineHeight)" }, h2: { fontSize: "var(--sparta-components-typography-sizes-h2-fontSize)", lineHeight: "var(--sparta-components-typography-sizes-h2-lineHeight)" }, h3: { fontSize: "var(--sparta-components-typography-sizes-h3-fontSize)", lineHeight: "var(--sparta-components-typography-sizes-h3-lineHeight)" }, h4: { fontSize: "var(--sparta-components-typography-sizes-h4-fontSize)", lineHeight: "var(--sparta-components-typography-sizes-h4-lineHeight)" }, body0: { fontSize: "var(--sparta-components-typography-sizes-body0-fontSize)", lineHeight: "var(--sparta-components-typography-sizes-body0-lineHeight)" }, body1: { fontSize: "var(--sparta-components-typography-sizes-body1-fontSize)", lineHeight: "var(--sparta-components-typography-sizes-body1-lineHeight)" }, body2: { fontSize: "var(--sparta-components-typography-sizes-body2-fontSize)", lineHeight: "var(--sparta-components-typography-sizes-body2-lineHeight)" }, body3: { fontSize: "var(--sparta-components-typography-sizes-body3-fontSize)", lineHeight: "var(--sparta-components-typography-sizes-body3-lineHeight)" }, body4: { fontSize: "var(--sparta-components-typography-sizes-body4-fontSize)", lineHeight: "var(--sparta-components-typography-sizes-body4-lineHeight)" }, body5: { fontSize: "var(--sparta-components-typography-sizes-body5-fontSize)", lineHeight: "var(--sparta-components-typography-sizes-body5-lineHeight)" } } }, shadows: { 5: "var(--sparta-components-shadows-5)" }, spacing: { 0: "var(--sparta-components-spacing-0)", 2: "var(--sparta-components-spacing-2)", 4: "var(--sparta-components-spacing-4)", 6: "var(--sparta-components-spacing-6)", 8: "var(--sparta-components-spacing-8)", 12: "var(--sparta-components-spacing-12)", 16: "var(--sparta-components-spacing-16)", 20: "var(--sparta-components-spacing-20)", 24: "var(--sparta-components-spacing-24)", 40: "var(--sparta-components-spacing-40)", 48: "var(--sparta-components-spacing-48)" }, breakpoints: { xs: "var(--sparta-components-breakpoints-xs)", sm: "var(--sparta-components-breakpoints-sm)", md: "var(--sparta-components-breakpoints-md)", lg: "var(--sparta-components-breakpoints-lg)", xl: "var(--sparta-components-breakpoints-xl)" }, layers: { hidden: { min: "var(--sparta-components-layers-hidden-min)", max: "var(--sparta-components-layers-hidden-max)" }, default: { min: "var(--sparta-components-layers-default-min)", max: "var(--sparta-components-layers-default-max)" }, base: { min: "var(--sparta-components-layers-base-min)", max: "var(--sparta-components-layers-base-max)" }, dropdown: { min: "var(--sparta-components-layers-dropdown-min)", max: "var(--sparta-components-layers-dropdown-max)" }, tooltip: { min: "var(--sparta-components-layers-tooltip-min)", max: "var(--sparta-components-layers-tooltip-max)" }, notification: { min: "var(--sparta-components-layers-notification-min)", max: "var(--sparta-components-layers-notification-max)" }, modal: { min: "var(--sparta-components-layers-modal-min)", max: "var(--sparta-components-layers-modal-max)" }, extra: { min: "var(--sparta-components-layers-extra-min)", max: "var(--sparta-components-layers-extra-max)" } } };
const Ca = Ie.createContext(Z), ao = ({ children: e }) => /* @__PURE__ */ a(Ca.Provider, { value: { ...Z }, children: e }), ro = () => ye(Ca);
var Cr = /* @__PURE__ */ ((e) => (e.SIZES = "sizes", e.FAMILY = "family", e.WEIGHT = "weight", e))(Cr || {}), fr = /* @__PURE__ */ ((e) => (e.BOLD = "bold", e.SEMIBOLD = "semibold", e.REGULAR = "regular", e))(fr || {}), ge = /* @__PURE__ */ ((e) => (e.H1 = "h1", e.H2 = "h2", e.H3 = "h3", e.H4 = "h4", e.BODY0 = "body0", e.BODY1 = "body1", e.BODY2 = "body2", e.BODY3 = "body3", e.BODY4 = "body4", e.BODY5 = "body5", e))(ge || {}), kr = /* @__PURE__ */ ((e) => (e.XS = "xs", e.SM = "sm", e.MD = "md", e.LG = "lg", e.XL = "xl", e))(kr || {}), O = /* @__PURE__ */ ((e) => (e.HEATMAP = "heatmap", e.MAIN = "main", e.NEUTRAL = "neutral", e.NEUTRAL_BLUE = "neutral_blue", e.BLUE_DARK = "blue_dark", e.BLUE_LIGHT = "blue_light", e.FEEDBACK_SUCCESS = "feedback_success", e.FEEDBACK_WARNING = "feedback_warning", e.FEEDBACK_ALERT = "feedback_alert", e.FEEDBACK_ERROR = "feedback_error", e.GRAPH = "graph", e.MENU_BUTTON = "menu_button", e.PROVIDERS = "providers", e.IOS = "ios", e))(O || {});
O.MAIN + "", O.NEUTRAL + "", O.NEUTRAL_BLUE + "", O.BLUE_DARK + "", O.BLUE_LIGHT + "", O.FEEDBACK_SUCCESS + "", O.FEEDBACK_WARNING + "", O.FEEDBACK_ALERT + "", O.FEEDBACK_ERROR + "", O.GRAPH + "", O.HEATMAP + "", O.MENU_BUTTON + "", O.PROVIDERS + "", O.IOS + "";
const we = {
  [O.MAIN]: {
    primary: "#2196F3",
    light: "#64B5F6",
    dark: "#1976D2",
    darker: "#134980"
  },
  [O.NEUTRAL]: {
    dark_00: "#FFF",
    dark_10: "#E6E6E6",
    dark_35: "#A7A7A7",
    dark_45: "#808080",
    dark_95: "#151515",
    dark_100: "#000"
  },
  [O.NEUTRAL_BLUE]: {
    dark_20: "#BCBCE5",
    dark_35: "#8686A7",
    dark_45: "#666680",
    dark_70: "#3E3E4D",
    dark_73: "#373A4D",
    dark_75: "#303343",
    dark_77: "#2C2F3A",
    dark_79: "#252831",
    dark_80: "#232530",
    dark_82: "#1F222A",
    dark_85: "#1E202A",
    dark_87: "#1E1E25",
    dark_90: "#171B26",
    dark_95: "#111115"
  },
  [O.BLUE_DARK]: {
    dark_01: "#04048C",
    dark_02: "#080878",
    dark_03: "#030355",
    dark_04: "#040A2B",
    dark_05: "#01011D"
  },
  [O.BLUE_LIGHT]: {
    light_01: "#3A3AD8",
    light_02: "#526CE0",
    light_03: "#6B99E6",
    light_04: "#84BEEC",
    light_05: "#B9F2F6"
  },
  [O.FEEDBACK_SUCCESS]: {
    principal: "#32B96C",
    bright: "#20DD71",
    light: "#5BC789",
    dark_01: "#249855",
    medium: "#249855",
    dark: "#23814B",
    dark_02: "#166638",
    shaded: "#166638",
    darker: "#1F3B2B"
  },
  [O.FEEDBACK_WARNING]: {
    principal: "#FBE204",
    light: "#FFF7AE",
    dark: "#FBC504",
    darker: "#C5CD1F"
  },
  [O.FEEDBACK_ALERT]: {
    principal: "#FB7B04",
    light: "#FB9536",
    dark: "#AF5602"
  },
  [O.FEEDBACK_ERROR]: {
    principal: "#FF3C3C",
    light: "#FF6363",
    dark: "#B22A2A",
    darker: "#402323"
  },
  [O.GRAPH]: {
    1: {
      principal: "#0079E9",
      light: "#77A8D6",
      dark: "#4B6D8D",
      greyish: "#4B6D8D",
      darker: "#165C9D"
    },
    2: {
      principal: "#D32C2C",
      light: "#F59F9F",
      dark: "#986666",
      greyish: "#986666",
      darker: "#802C2C"
    },
    3: {
      principal: "#53C151",
      light: "#ABE3AA",
      dark: "#5C805B",
      greyish: "#5C805B",
      darker: "#0C5F0A"
    },
    4: {
      principal: "#9D20C9",
      light: "#C376DE",
      dark: "#886594",
      greyish: "#886594",
      darker: "#5E007F"
    },
    5: {
      principal: "#D4C217",
      light: "#DBD6A6",
      dark: "#96926A",
      greyish: "#96926A",
      darker: "#70660B"
    },
    6: {
      principal: "#B6B6B6",
      light: "#F6F6F6",
      dark: "#7F7F7F",
      greyish: "#7F7F7F",
      darker: "#404040"
    },
    7: {
      principal: "#DC9100",
      light: "#F9D182",
      dark: "#86724E",
      greyish: "#86724E",
      darker: "#764E00"
    },
    8: {
      principal: "#38DBBD",
      light: "#9AE3D5",
      dark: "#557C75",
      greyish: "#557C75",
      darker: "#00705B"
    },
    9: {
      principal: "#E833AA",
      light: "#F196D1",
      dark: "#966E88",
      greyish: "#966E88",
      darker: "#790451"
    },
    10: {
      principal: "#2F2BFA",
      light: "#A2A0FF",
      dark: "#57558E",
      greyish: "#57558E",
      darker: "#32309F"
    }
  },
  [O.HEATMAP]: {
    0: "#992020",
    1: "#AE4519",
    2: "#C26913",
    3: "#D68B0D",
    4: "#F5C203",
    5: "#D9C40B",
    6: "#ABB01A",
    7: "#7E9C28",
    8: "#528935",
    9: "#227444"
  },
  [O.MENU_BUTTON]: {
    main: "#262645",
    hover: "#232F5A",
    disabled: "#525266"
  },
  [O.PROVIDERS]: { 1: "#5F7EED", "1-hover": "#5169BE", 2: "#E62E2D", "2-hover": "#BB2D2F" },
  [O.IOS]: { light: "#FFFFFF26", dark: "#27273F80", main_greyish: "#48789D" }
};
var G = /* @__PURE__ */ ((e) => (e.HIDDEN = "hidden", e.DEFAULT = "default", e.BASE = "base", e.DROPDOWN = "dropdown", e.TOOLTIP = "tooltip", e.NOTIFICATION = "notification", e.MODAL = "modal", e.EXTRA = "extra", e))(G || {});
const to = {
  [G.HIDDEN]: { min: "-1", max: "-1" },
  [G.DEFAULT]: { min: "0", max: "0" },
  [G.BASE]: { min: "1", max: "199" },
  [G.DROPDOWN]: { min: "400", max: "499" },
  [G.TOOLTIP]: { min: "600", max: "699" },
  [G.NOTIFICATION]: { min: "800", max: "899" },
  [G.MODAL]: { min: "900", max: "999" },
  [G.EXTRA]: { min: "9999", max: "9999" }
}, fa = ({ elementRef: e, onClickAway: r }) => M(() => {
  const t = (A) => {
    e?.current?.contains(A.target) || r();
  };
  return document.addEventListener("mousedown", t, !1), document.addEventListener("touchend", t, !1), () => {
    document.removeEventListener("mousedown", t, !1), document.removeEventListener("touchend", t, !1);
  };
}, [r]), je = Object.freeze({
  ENTER: "Enter",
  SPACE: " "
});
function Er(e) {
  return e instanceof HTMLInputElement || e instanceof HTMLTextAreaElement || e instanceof HTMLSelectElement || e instanceof HTMLAnchorElement && e.href || e instanceof HTMLButtonElement && (e.type === "submit" || e.type === "reset") ? !0 : e instanceof HTMLElement && e.isContentEditable;
}
function br(e) {
  const { onKeyDown: r, ...t } = e;
  return {
    ...t,
    onKeyDown: (n) => {
      r?.(n);
      const { currentTarget: s } = n;
      if (n.key === je.SPACE || n.key === je.ENTER) {
        if (n.repeat || Er(s))
          return;
        n.preventDefault(), s.click();
      }
    }
  };
}
var Ir = "_1ljw9nc0", yr = "_1ljw9nc1";
function le(e) {
  const { children: r, className: t, disabled: A, tabIndex: n, ...s } = e, o = br(e), i = {
    ...s,
    ...o,
    className: Y(Ir, yr, t),
    disabled: A,
    tabIndex: A ? -1 : n
  };
  return /* @__PURE__ */ a("button", { ...i, children: r });
}
var h = /* @__PURE__ */ ((e) => (e.ARROW_BACK_IOS_NEW = "arrowBackIosNew", e.ARROW_DOWN = "arrowDown", e.ARROW_UP = "arrowUp", e.ARROW_LEFT = "arrowLeft", e.ARROW_RIGHT = "arrowRight", e.CHECK = "check", e.CLOCK = "clock", e.CLOSE = "close", e.DISTILLATE = "distillate", e.DOT = "dot", e.DRAG = "drag", e.GASOLINE = "gasoline", e.HIDE_IMAGE = "hideImage", e.INFO = "info", e.INFO_ROUND = "infoRound", e.PAUSE = "pause", e.FEEDBACK = "feedback", e.LINEAR_SCALE = "linearScale", e.PERSON = "person", e.FLASH_ON = "flashOn", e.TOUCH_APP = "touchApp", e.CIRCLED_CHECK = "circledCheck (deprecated)", e.CIRCLED_INFO_ROUND = "circledInfoRound (deprecated)", e.CLOSE_FULLSCREEN = "closeFullscreen", e.OPEN_IN_FULL = "openInFull", e.SPARTA_LOGO = "spartaLogo", e.RECTANGULAR_SKELETON = "rectangularSkeleton", e.FUELOIL_LOGO = "fueloilLogo", e.GRAPHIC_EQUALIZER = "graphicEqualizer", e.POST_ADD = "postAdd", e.ARROW_UPWARD = "arrowUpward", e.IMPORT_EXPORT = "importExport", e.WARNING_AMBER = "warningAmber", e.REPORT = "report", e.BAR_CHART = "barChart", e.DELETE = "delete", e.CANDLE_STICK = "candleStick", e))(h || {});
const Rr = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 16 16", ...e, children: /* @__PURE__ */ a("path", { d: "M11.368 1.924a.833.833 0 0 0-1.18 0L4.582 7.53c-.26.26-.26.68 0 .94l5.606 5.607a.833.833 0 0 0 1.18 0 .833.833 0 0 0 0-1.18L6.475 8.004l4.9-4.9a.839.839 0 0 0-.007-1.18Z" }) }), Nr = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ a("path", { d: "m8.125 9 3.88 3.88L15.885 9a.996.996 0 1 1 1.41 1.41L12.705 15a.996.996 0 0 1-1.41 0l-4.59-4.59a.996.996 0 0 1 0-1.41c.39-.38 1.03-.39 1.42 0Z" }) }), Sr = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ a("path", { d: "M15.7049 16.59L11.1249 12L15.7049 7.41L14.2949 6L8.29492 12L14.2949 18L15.7049 16.59Z" }) }), Dr = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ a("path", { d: "M8.29504 16.59L12.875 12L8.29504 7.41L9.70504 6L15.705 12L9.70504 18L8.29504 16.59Z" }) }), Hr = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ a("path", { d: "m8.125 15 3.88-3.88 3.88 3.88a.996.996 0 1 0 1.41-1.41L12.705 9a.996.996 0 0 0-1.41 0l-4.59 4.59a.996.996 0 0 0 0 1.41c.39.38 1.03.39 1.42 0Z" }) }), Or = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 12 12", xmlns: "http://www.w3.org/2000/svg", ...e, children: /* @__PURE__ */ a("g", { id: "arrow_upward", children: /* @__PURE__ */ a(
  "path",
  {
    d: "M6.49986 9.39574V3.81074L8.93986 6.25074C9.13486 6.44574 9.45486 6.44574 9.64986 6.25074C9.84486 6.05574 9.84486 5.74074 9.64986 5.54574L6.35486 2.25074C6.15986 2.05574 5.84486 2.05574 5.64986 2.25074L2.34986 5.54074C2.15486 5.73574 2.15486 6.05074 2.34986 6.24574C2.54486 6.44074 2.85986 6.44074 3.05486 6.24574L5.49986 3.81074V9.39574C5.49986 9.67074 5.72486 9.89574 5.99986 9.89574C6.27486 9.89574 6.49986 9.67074 6.49986 9.39574Z",
    id: "Vector"
  }
) }) }), wr = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 12 12", ...e, children: /* @__PURE__ */ a("path", { d: "M3.2 4.6H3.3C3.685 4.6 4 4.915 4 5.3V8.8C4 9.185 3.685 9.5 3.3 9.5H3.2C2.815 9.5 2.5 9.185 2.5 8.8V5.3C2.5 4.915 2.815 4.6 3.2 4.6ZM6 2.5C6.385 2.5 6.7 2.815 6.7 3.2V8.8C6.7 9.185 6.385 9.5 6 9.5C5.615 9.5 5.3 9.185 5.3 8.8V3.2C5.3 2.815 5.615 2.5 6 2.5ZM8.8 6.5C9.185 6.5 9.5 6.815 9.5 7.2V8.8C9.5 9.185 9.185 9.5 8.8 9.5C8.415 9.5 8.1 9.185 8.1 8.8V7.2C8.1 6.815 8.415 6.5 8.8 6.5Z" }) }), Lr = (e) => /* @__PURE__ */ b("svg", { viewBox: "0 0 15 15", ...e, children: [
  /* @__PURE__ */ a("path", { d: "M5 2.5C4.65625 2.5 4.375 2.78125 4.375 3.125V3.75H3.75C3.40625 3.75 3.125 4.03125 3.125 4.375V10.625C3.125 10.9688 3.40625 11.25 3.75 11.25H4.375V11.875C4.375 12.2188 4.65625 12.5 5 12.5C5.34375 12.5 5.625 12.2188 5.625 11.875V11.25H6.25C6.59375 11.25 6.875 10.9688 6.875 10.625V4.375C6.875 4.03125 6.59375 3.75 6.25 3.75H5.625V3.125C5.625 2.78125 5.34375 2.5 5 2.5Z" }),
  /* @__PURE__ */ a("path", { d: "M11.25 5H10.625V3.125C10.625 2.78125 10.3438 2.5 10 2.5C9.65625 2.5 9.375 2.78125 9.375 3.125V5H8.75C8.40625 5 8.125 5.28125 8.125 5.625V8.75C8.125 9.09375 8.40625 9.375 8.75 9.375H9.375V11.875C9.375 12.2188 9.65625 12.5 10 12.5C10.3438 12.5 10.625 12.2188 10.625 11.875V9.375H11.25C11.5938 9.375 11.875 9.09375 11.875 8.75V5.625C11.875 5.28125 11.5938 5 11.25 5Z" })
] }), Ue = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 46 46", ...e, children: /* @__PURE__ */ a("path", { d: "m16.857 30.427-6.65-6.651a1.909 1.909 0 0 0-2.703 0 1.909 1.909 0 0 0 0 2.703l8.012 8.011a1.909 1.909 0 0 0 2.702 0l20.278-20.278a1.909 1.909 0 0 0 0-2.703 1.909 1.909 0 0 0-2.702 0L16.857 30.427Z" }) }), Qr = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ a("path", { d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z" }) }), Br = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 14 14", ...e, children: /* @__PURE__ */ a("path", { d: "M6.994 1.167A5.83 5.83 0 0 0 1.167 7a5.83 5.83 0 0 0 5.827 5.833A5.837 5.837 0 0 0 12.834 7a5.837 5.837 0 0 0-5.84-5.833ZM7 11.667A4.665 4.665 0 0 1 2.333 7 4.665 4.665 0 0 1 7 2.333 4.665 4.665 0 0 1 11.667 7 4.665 4.665 0 0 1 7 11.667Zm.292-7.584h-.875v3.5l3.062 1.838.438-.718-2.625-1.557V4.083Z" }) }), Vr = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 32 32", ...e, children: /* @__PURE__ */ a("path", { d: "M24.4 7.613c-.52-.52-1.36-.52-1.88 0L16 14.12 9.48 7.6c-.52-.52-1.36-.52-1.88 0-.52.52-.52 1.36 0 1.88L14.12 16 7.6 22.52c-.52.52-.52 1.36 0 1.88.52.52 1.36.52 1.88 0L16 17.88l6.52 6.52c.52.52 1.36.52 1.88 0 .52-.52.52-1.36 0-1.88L17.88 16l6.52-6.52a1.336 1.336 0 0 0 0-1.867Z" }) }), Tr = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 20 20", ...e, children: /* @__PURE__ */ a("path", { d: "M17.7453 3.43709L13.9203 7.26209L15.2453 8.58709C15.7703 9.11209 15.3953 10.0121 14.6536 10.0121H10.837C10.3786 10.0121 10.0036 9.63709 10.0036 9.17876V5.34543C10.0036 4.60376 10.9036 4.22876 11.4286 4.75376L12.7536 6.07876L16.5786 2.25376C16.9036 1.92876 17.4286 1.92876 17.7536 2.25376C18.0703 2.58709 18.0703 3.11209 17.7453 3.43709ZM3.43697 17.7454L7.26197 13.9204L8.58697 15.2454C9.11197 15.7704 10.012 15.3954 10.012 14.6538V10.8371C10.012 10.3788 9.63697 10.0038 9.17864 10.0038H5.3453C4.60364 10.0038 4.22864 10.9038 4.75364 11.4288L6.07864 12.7538L2.25364 16.5788C1.92864 16.9038 1.92864 17.4288 2.25364 17.7538C2.58697 18.0704 3.11197 18.0704 3.43697 17.7454Z" }) }), qr = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 15 15", ...e, children: /* @__PURE__ */ a("g", { id: "delete_outline", children: /* @__PURE__ */ a(
  "path",
  {
    d: "M3.75 11.875C3.75 12.5625 4.3125 13.125 5 13.125H10C10.6875 13.125 11.25 12.5625 11.25 11.875V5.625C11.25 4.9375 10.6875 4.375 10 4.375H5C4.3125 4.375 3.75 4.9375 3.75 5.625V11.875ZM5.625 5.625H9.375C9.71875 5.625 10 5.90625 10 6.25V11.25C10 11.5938 9.71875 11.875 9.375 11.875H5.625C5.28125 11.875 5 11.5938 5 11.25V6.25C5 5.90625 5.28125 5.625 5.625 5.625ZM9.6875 2.5L9.24375 2.05625C9.13125 1.94375 8.96875 1.875 8.80625 1.875H6.19375C6.03125 1.875 5.86875 1.94375 5.75625 2.05625L5.3125 2.5H3.75C3.40625 2.5 3.125 2.78125 3.125 3.125C3.125 3.46875 3.40625 3.75 3.75 3.75H11.25C11.5938 3.75 11.875 3.46875 11.875 3.125C11.875 2.78125 11.5938 2.5 11.25 2.5H9.6875Z",
    id: "Vector"
  }
) }) }), xr = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ a("path", { d: "M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5m13.5-9 1.96 2.5H17V9.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5" }) }), zr = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 14 14", ...e, children: /* @__PURE__ */ a("path", { d: "M7 3C4.788 3 3 4.788 3 7c0 2.212 1.788 4 4 4 2.212 0 4-1.788 4-4 0-2.212-1.788-4-4-4Z" }) }), Mr = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 7 11", ...e, children: /* @__PURE__ */ a("path", { d: "M2.875 9.25C2.875 9.9375 2.3125 10.5 1.625 10.5C0.9375 10.5 0.375 9.9375 0.375 9.25C0.375 8.5625 0.9375 8 1.625 8C2.3125 8 2.875 8.5625 2.875 9.25ZM1.625 4.25C0.9375 4.25 0.375 4.8125 0.375 5.5C0.375 6.1875 0.9375 6.75 1.625 6.75C2.3125 6.75 2.875 6.1875 2.875 5.5C2.875 4.8125 2.3125 4.25 1.625 4.25ZM1.625 0.5C0.9375 0.5 0.375 1.0625 0.375 1.75C0.375 2.4375 0.9375 3 1.625 3C2.3125 3 2.875 2.4375 2.875 1.75C2.875 1.0625 2.3125 0.5 1.625 0.5ZM5.375 3C6.0625 3 6.625 2.4375 6.625 1.75C6.625 1.0625 6.0625 0.5 5.375 0.5C4.6875 0.5 4.125 1.0625 4.125 1.75C4.125 2.4375 4.6875 3 5.375 3ZM5.375 4.25C4.6875 4.25 4.125 4.8125 4.125 5.5C4.125 6.1875 4.6875 6.75 5.375 6.75C6.0625 6.75 6.625 6.1875 6.625 5.5C6.625 4.8125 6.0625 4.25 5.375 4.25ZM5.375 8C4.6875 8 4.125 8.5625 4.125 9.25C4.125 9.9375 4.6875 10.5 5.375 10.5C6.0625 10.5 6.625 9.9375 6.625 9.25C6.625 8.5625 6.0625 8 5.375 8Z" }) }), Wr = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 30 30", ...e, children: /* @__PURE__ */ a("path", { d: "M25 2.5H5C3.625 2.5 2.5125 3.625 2.5125 5L2.5 27.5L7.5 22.5H25C26.375 22.5 27.5 21.375 27.5 20V5C27.5 3.625 26.375 2.5 25 2.5ZM25 20H6.4625L5 21.4625V5H25V20ZM13.75 15H16.25V17.5H13.75V15ZM13.75 7.5H16.25V12.5H13.75V7.5Z" }) }), Pr = (e) => /* @__PURE__ */ a("svg", { ...e, viewBox: "0 0 12 12", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ a("path", { d: "M3.685 1.838v4.5c0 .275.225.5.5.5h1v3.575c0 .255.335.345.465.125l2.595-4.45a.498.498 0 0 0-.43-.75h-1.13L7.93 2.013a.497.497 0 0 0-.465-.675h-3.28c-.275 0-.5.225-.5.5Z" }) }), Xr = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 20 20", ...e, children: /* @__PURE__ */ a("path", { d: "M5.8637 5.8414L5.85856 5.8335H5.8637V5.8414ZM5.8637 5.8414L7.78035 5.84127C7.92926 5.84127 8.04985 5.97194 8.04985 6.13301V8.54588C8.048 8.70548 7.92791 8.83375 7.78035 8.83375H3.81755C3.72318 8.83455 3.63525 8.78167 3.5859 8.69437C3.53655 8.6072 3.53296 8.49848 3.5765 8.40771L4.71471 6.0006C4.76097 5.90259 4.85422 5.84086 4.95589 5.84127L5.8637 5.8414ZM8.67396 7.70328H11.2076C11.3564 7.70328 11.4771 7.86435 11.4771 7.99503V8.54787C11.4771 8.70894 11.3564 8.83961 11.2076 8.83961H8.67396C8.52517 8.83961 8.40446 8.67854 8.40446 8.54787V7.99503C8.40446 7.83396 8.52517 7.70328 8.67396 7.70328ZM17.9791 13.0144C17.6532 13.0064 17.3303 13.0835 17.0376 13.2389C16.6233 13.4507 16.1433 13.4507 15.7291 13.2389L15.6741 13.2064L17.4614 9.65538C17.5081 9.5646 17.5067 9.45387 17.4578 9.36456C17.4088 9.27512 17.3197 9.22077 17.2238 9.22157H2.79639C2.69782 9.21742 2.60506 9.27178 2.55447 9.36336C2.50376 9.45494 2.50339 9.56915 2.55348 9.66113L4.42056 13.1604L4.26979 13.2295C4.06893 13.3442 3.84444 13.4023 3.61727 13.3983C3.39032 13.4055 3.16536 13.3508 2.96301 13.239C2.67038 13.0835 2.34747 13.0064 2.02157 13.0144C1.82567 13.0144 1.66699 13.1864 1.66699 13.3983C1.66699 13.6104 1.82567 13.7822 2.02157 13.7822C2.24853 13.7751 2.47348 13.8298 2.67584 13.9415C2.96846 14.0971 3.29137 14.1741 3.61727 14.1662C3.94329 14.1741 4.26621 14.0971 4.55883 13.9415C4.76105 13.8297 4.98601 13.7749 5.21309 13.7822C5.44005 13.7749 5.665 13.8297 5.86736 13.9415C6.15998 14.0972 6.48289 14.1742 6.80879 14.1662C7.13481 14.1742 7.45773 14.0972 7.75035 13.9415C7.95257 13.8297 8.17754 13.7749 8.40461 13.7822C8.63157 13.7749 8.85652 13.8297 9.05888 13.9415C9.3515 14.0972 9.67442 14.1742 10.0003 14.1662C10.3262 14.1741 10.6491 14.0971 10.9417 13.9415C11.3559 13.7294 11.8362 13.7294 12.2503 13.9415C12.8479 14.2419 13.5375 14.2419 14.1351 13.9415C14.5493 13.7297 15.0293 13.7297 15.4437 13.9415C16.0413 14.2417 16.7307 14.2417 17.3284 13.9415C17.5296 13.8305 17.7532 13.7757 17.9791 13.7822C18.175 13.7822 18.3337 13.6104 18.3337 13.3983C18.3337 13.1863 18.175 13.0144 17.9791 13.0144L17.9791 13.0144Z" }) }), Fr = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ a("path", { d: "m19.77 7.23.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33a2.5 2.5 0 0 0 2.5 2.5c.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5a2.5 2.5 0 0 0 5 0V9c0-.69-.28-1.32-.73-1.77M12 10H6V5h6zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1" }) }), Zr = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ a("path", { d: "M8 18C8.55 18 9 17.55 9 17V7C9 6.45 8.55 6 8 6C7.45 6 7 6.45 7 7V17C7 17.55 7.45 18 8 18ZM12 22C12.55 22 13 21.55 13 21V3C13 2.45 12.55 2 12 2C11.45 2 11 2.45 11 3V21C11 21.55 11.45 22 12 22ZM4 14C4.55 14 5 13.55 5 13V11C5 10.45 4.55 10 4 10C3.45 10 3 10.45 3 11V13C3 13.55 3.45 14 4 14ZM16 18C16.55 18 17 17.55 17 17V7C17 6.45 16.55 6 16 6C15.45 6 15 6.45 15 7V17C15 17.55 15.45 18 16 18ZM19 11V13C19 13.55 19.45 14 20 14C20.55 14 21 13.55 21 13V11C21 10.45 20.55 10 20 10C19.45 10 19 10.45 19 11Z" }) }), jr = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 64 64", ...e, children: /* @__PURE__ */ a("path", { d: "M52.257 6.41h-35.12L57.59 46.864v-35.12c0-2.934-2.4-5.334-5.333-5.334ZM10.95 7.77a2.656 2.656 0 0 0-3.76 0 2.656 2.656 0 0 0 0 3.76l2.4 2.427v35.12c0 2.933 2.4 5.333 5.334 5.333h35.12l2.4 2.4a2.656 2.656 0 0 0 3.76 0 2.656 2.656 0 0 0 0-3.76L10.95 7.77Zm9.307 35.974c-1.094 0-1.734-1.254-1.067-2.134l5.333-7.12c.534-.72 1.6-.72 2.134 0l4.933 6.587 2.187-2.933 5.6 5.6h-19.12Z" }) }), Ur = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 12 12", xmlns: "http://www.w3.org/2000/svg", ...e, children: /* @__PURE__ */ a("g", { id: "import_export", children: /* @__PURE__ */ a(
  "path",
  {
    d: "M4.32282 1.67745L2.92782 3.07245C2.76782 3.22745 2.87782 3.49745 3.10282 3.49745H3.99782V6.50245C3.99782 6.77745 4.22282 7.00245 4.49782 7.00245C4.77282 7.00245 4.99782 6.77745 4.99782 6.50245V3.49745H5.89282C6.11782 3.49745 6.22782 3.22745 6.06782 3.07245L4.67282 1.67745C4.57782 1.58245 4.41782 1.58245 4.32282 1.67745ZM7.99782 8.50745V5.50245C7.99782 5.22745 7.77282 5.00245 7.49782 5.00245C7.22282 5.00245 6.99782 5.22745 6.99782 5.50245V8.50745H6.10282C5.87782 8.50745 5.76782 8.77745 5.92782 8.93245L7.32282 10.3224C7.42282 10.4174 7.57782 10.4174 7.67782 10.3224L9.07282 8.93245C9.23282 8.77745 9.11782 8.50745 8.89782 8.50745H7.99782Z",
    id: "Vector"
  }
) }) }), Gr = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 16 16", ...e, children: /* @__PURE__ */ a("path", { d: "M7.333 4.667h1.334V6H7.334V4.667Zm0 2.666h1.334v4H7.334v-4Zm.667-6A6.67 6.67 0 0 0 1.333 8 6.67 6.67 0 0 0 8 14.667 6.67 6.67 0 0 0 14.667 8 6.67 6.67 0 0 0 8 1.333Zm0 12A5.34 5.34 0 0 1 2.667 8 5.34 5.34 0 0 1 8 2.667 5.34 5.34 0 0 1 13.334 8 5.34 5.34 0 0 1 8 13.333Z" }) }), Ge = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 46 46", ...e, children: /* @__PURE__ */ a("path", { d: "M23 3.833C12.42 3.833 3.835 12.42 3.835 23c0 10.58 8.587 19.167 19.167 19.167 10.58 0 19.166-8.587 19.166-19.167 0-10.58-8.586-19.166-19.166-19.166Zm0 28.75a1.922 1.922 0 0 1-1.916-1.916V23c0-1.054.863-1.916 1.917-1.916s1.916.862 1.916 1.916v7.667a1.922 1.922 0 0 1-1.916 1.916Zm1.917-15.333h-3.833v-3.833h3.833v3.833Z" }) }), Yr = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 15 15", ...e, children: /* @__PURE__ */ a("path", { d: "M12.1875 5.9375C11.5437 5.9375 11 6.325 10.7562 6.875H8.93125C8.6875 6.325 8.14375 5.9375 7.5 5.9375C6.85625 5.9375 6.3125 6.325 6.06875 6.875H4.24375C4 6.325 3.45625 5.9375 2.8125 5.9375C1.95 5.9375 1.25 6.6375 1.25 7.5C1.25 8.3625 1.95 9.0625 2.8125 9.0625C3.45625 9.0625 4 8.675 4.24375 8.125H6.06875C6.3125 8.675 6.85625 9.0625 7.5 9.0625C8.14375 9.0625 8.6875 8.675 8.93125 8.125H10.7562C11 8.675 11.5437 9.0625 12.1875 9.0625C13.05 9.0625 13.75 8.3625 13.75 7.5C13.75 6.6375 13.05 5.9375 12.1875 5.9375Z" }) }), Jr = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 20 20", ...e, children: /* @__PURE__ */ a("path", { d: "M17.5 7.15833V3.33333C17.5 2.875 17.125 2.5 16.6667 2.5H12.8417C12.1 2.5 11.725 3.4 12.25 3.925L13.575 5.25L5.24167 13.5833L3.91667 12.2583C3.4 11.7333 2.5 12.1 2.5 12.8417V16.6667C2.5 17.125 2.875 17.5 3.33333 17.5H7.15833C7.9 17.5 8.275 16.6 7.75 16.075L6.425 14.75L14.7583 6.41667L16.0833 7.74167C16.6 8.26667 17.5 7.9 17.5 7.15833Z" }) }), Kr = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 14 14", ...e, children: /* @__PURE__ */ a("path", { d: "M3.5 11.083h2.333V2.917H3.5v8.166Zm4.667-8.166v8.166H10.5V2.917H8.167Z" }) }), _r = (e) => /* @__PURE__ */ b("svg", { viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ a("path", { d: "M12 6C13.1 6 14 6.9 14 8C14 9.1 13.1 10 12 10C10.9 10 10 9.1 10 8C10 6.9 10.9 6 12 6ZM12 16C14.7 16 17.8 17.29 18 18H6C6.23 17.28 9.31 16 12 16ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" }),
  " "
] }), $r = (e) => /* @__PURE__ */ b("svg", { viewBox: "0 0 20 20", ...e, children: [
  /* @__PURE__ */ a("path", { d: "M14.5835 10.4167C14.1252 10.4167 13.7502 10.7917 13.7502 11.25V15.6C13.7502 16.0583 13.3752 16.4333 12.9168 16.4333H4.5835C4.12516 16.4333 3.75016 16.0583 3.75016 15.6V7.08334C3.75016 6.62501 4.12516 6.25001 4.5835 6.25001H8.75016C9.2085 6.25001 9.5835 5.87501 9.5835 5.41668C9.5835 4.95834 9.2085 4.58334 8.75016 4.58334H3.75016C2.8335 4.58334 2.0835 5.33334 2.0835 6.25001V16.25C2.0835 17.1667 2.8335 17.9167 3.75016 17.9167H13.7502C14.6668 17.9167 15.4168 17.1667 15.4168 16.25V11.25C15.4168 10.7917 15.0418 10.4167 14.5835 10.4167Z" }),
  /* @__PURE__ */ a("path", { d: "M17.1002 4.58334H15.4168V2.90001C15.4168 2.45001 15.0502 2.08334 14.6002 2.08334H14.5752C14.1168 2.08334 13.7502 2.45001 13.7502 2.90001V4.58334H12.0752C11.6252 4.58334 11.2585 4.95001 11.2502 5.40001C11.2502 5.40834 11.2502 5.41668 11.2502 5.42501C11.2502 5.88334 11.6168 6.25001 12.0752 6.25001H13.7502V7.92501C13.7502 8.37501 14.1168 8.75001 14.5752 8.74168C14.5835 8.74168 14.5918 8.74168 14.6002 8.74168C15.0502 8.74168 15.4168 8.37501 15.4168 7.92501V6.25001H17.1002C17.5502 6.25001 17.9168 5.88334 17.9168 5.43334V5.40001C17.9168 4.95001 17.5502 4.58334 17.1002 4.58334Z" }),
  /* @__PURE__ */ a("path", { d: "M11.2502 7.91668H6.25016C5.79183 7.91668 5.41683 8.29168 5.41683 8.75001C5.41683 9.20834 5.79183 9.58334 6.25016 9.58334H11.2502C11.7085 9.58334 12.0835 9.20834 12.0835 8.75001C12.0835 8.29168 11.7085 7.91668 11.2502 7.91668Z" }),
  /* @__PURE__ */ a("path", { d: "M11.2502 10.4167H6.25016C5.79183 10.4167 5.41683 10.7917 5.41683 11.25C5.41683 11.7083 5.79183 12.0833 6.25016 12.0833H11.2502C11.7085 12.0833 12.0835 11.7083 12.0835 11.25C12.0835 10.7917 11.7085 10.4167 11.2502 10.4167Z" }),
  /* @__PURE__ */ a("path", { d: "M11.2502 12.9167H6.25016C5.79183 12.9167 5.41683 13.2917 5.41683 13.75C5.41683 14.2083 5.79183 14.5833 6.25016 14.5833H11.2502C11.7085 14.5833 12.0835 14.2083 12.0835 13.75C12.0835 13.2917 11.7085 12.9167 11.2502 12.9167Z" })
] }), et = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...e, children: /* @__PURE__ */ a("rect", { height: "12", rx: "2", width: "12", x: "4", y: "4" }) }), at = (e) => /* @__PURE__ */ b("svg", { viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ a("path", { d: "M15.73 3H8.27L3 8.27V15.73L8.27 21H15.73L21 15.73V8.27L15.73 3ZM19 14.9L14.9 19H9.1L5 14.9V9.1L9.1 5H14.9L19 9.1V14.9Z" }),
  /* @__PURE__ */ a("path", { d: "M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z" }),
  /* @__PURE__ */ a("path", { d: "M11 7H13V14H11V7Z" })
] }), rt = (e) => /* @__PURE__ */ b("svg", { viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ a("g", { clipPath: "url(#clip0_7742_3529)", children: /* @__PURE__ */ a("g", { clipPath: "url(#clip1_7742_3529)", children: /* @__PURE__ */ a("rect", { fill: "url(#pattern0_7742_3529)", height: "41.1429", width: "41.1429", x: "-8.57153", y: "-5.14285" }) }) }),
  /* @__PURE__ */ b("defs", { children: [
    /* @__PURE__ */ a("pattern", { height: "1", id: "pattern0_7742_3529", patternContentUnits: "objectBoundingBox", width: "1", children: /* @__PURE__ */ a("use", { transform: "scale(0.000999001)", xlinkHref: "#image0_7742_3529" }) }),
    /* @__PURE__ */ a("clipPath", { id: "clip0_7742_3529", children: /* @__PURE__ */ a("rect", { fill: "white", height: "24", width: "24" }) }),
    /* @__PURE__ */ a("clipPath", { id: "clip1_7742_3529", children: /* @__PURE__ */ a("rect", { fill: "white", height: "24", width: "24" }) }),
    /* @__PURE__ */ a(
      "image",
      {
        height: "1001",
        id: "image0_7742_3529",
        width: "1001",
        xlinkHref: "data:image/png;base64,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"
      }
    )
  ] })
] }), tt = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 12 12", ...e, children: /* @__PURE__ */ a("path", { d: "M4.27577 4.87V3C4.27577 2.31 4.83577 1.75 5.52577 1.75C6.21577 1.75 6.77577 2.31 6.77577 3V4.87C7.38077 4.465 7.77577 3.78 7.77577 3C7.77577 1.755 6.77077 0.75 5.52577 0.75C4.28077 0.75 3.27577 1.755 3.27577 3C3.27577 3.78 3.67077 4.465 4.27577 4.87ZM7.02577 6.105C6.88577 6.035 6.73577 6 6.58077 6H6.27577V3C6.27577 2.585 5.94077 2.25 5.52577 2.25C5.11077 2.25 4.77577 2.585 4.77577 3V8.37L3.05577 8.01C2.87077 7.97 2.67577 8.03 2.54077 8.165C2.32577 8.385 2.32577 8.735 2.54077 8.955L4.54577 10.96C4.73577 11.145 4.99077 11.25 5.25577 11.25H8.30577C8.80577 11.25 9.22577 10.885 9.29577 10.39L9.61077 8.155C9.67077 7.73 9.45077 7.31 9.06577 7.12L7.02577 6.105Z" }) }), At = (e) => /* @__PURE__ */ a("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ a("path", { d: "M12 6.49L19.53 19.5H4.47L12 6.49ZM12 2.5L1 21.5H23L12 2.5ZM13 16.5H11V18.5H13V16.5ZM13 10.5H11V14.5H13V10.5Z" }) }), He = {
  [h.ARROW_BACK_IOS_NEW]: { default: Rr },
  [h.ARROW_DOWN]: { default: Nr },
  [h.ARROW_UP]: { default: Hr },
  [h.ARROW_LEFT]: { default: Sr },
  [h.ARROW_RIGHT]: { default: Dr },
  [h.CHECK]: { default: Ue, circled: Qr },
  [h.CIRCLED_CHECK]: { default: Ue },
  [h.CIRCLED_INFO_ROUND]: { default: Ge },
  [h.CLOCK]: { default: Br },
  [h.CLOSE]: { default: Vr },
  [h.DISTILLATE]: { default: xr },
  [h.DOT]: { default: zr },
  [h.DRAG]: { default: Mr },
  [h.GASOLINE]: { default: Fr },
  [h.HIDE_IMAGE]: { default: jr },
  [h.INFO]: { default: Gr },
  [h.INFO_ROUND]: { default: Ge },
  [h.PAUSE]: { default: Kr },
  [h.LINEAR_SCALE]: { default: Yr },
  [h.FEEDBACK]: { default: Wr },
  [h.PERSON]: { default: _r },
  [h.FLASH_ON]: { default: Pr },
  [h.TOUCH_APP]: { default: tt },
  [h.CLOSE_FULLSCREEN]: { default: Tr },
  [h.OPEN_IN_FULL]: { default: Jr },
  [h.SPARTA_LOGO]: { default: rt },
  [h.RECTANGULAR_SKELETON]: { default: et },
  [h.FUELOIL_LOGO]: { default: Xr },
  [h.GRAPHIC_EQUALIZER]: { default: Zr },
  [h.POST_ADD]: { default: $r },
  [h.ARROW_UPWARD]: { default: Or },
  [h.IMPORT_EXPORT]: { default: Ur },
  [h.WARNING_AMBER]: { default: At },
  [h.REPORT]: { default: at },
  [h.BAR_CHART]: { default: wr },
  [h.DELETE]: { default: qr },
  [h.CANDLE_STICK]: { default: Lr }
}, nt = [h.CIRCLED_CHECK, h.CIRCLED_INFO_ROUND], ka = 20;
var st = "var(--_1vu5m8i0)", ot = "var(--_1vu5m8i1)", lt = "_1vu5m8i2", it = "_1vu5m8i3";
const T = ({ type: e, width: r = ka, height: t = r, fill: A, color: n, hoverColor: s, circled: o, ...i }) => {
  const c = o ?? nt.includes(e), l = A ?? n, d = c && typeof He[e].circled == "function" ? He[e].circled : He[e].default;
  return /* @__PURE__ */ a(
    "div",
    {
      className: lt,
      style: V({
        [st]: l,
        [ot]: s ?? l
      }),
      children: /* @__PURE__ */ a(d, { "aria-hidden": !0, className: it, "data-testid": e, focusable: !1, height: t, width: r, ...i })
    }
  );
};
var dt = "_1ez47ic1";
const Ea = ({ width: e = 12, height: r = 12, backgroundColor: t, ...A }) => /* @__PURE__ */ a(
  "svg",
  {
    className: dt,
    "data-testid": "sparta-spinner",
    height: r,
    style: { fill: t },
    viewBox: "0 0 12 12",
    width: e,
    xmlns: "http://www.w3.org/2000/svg",
    ...A,
    children: /* @__PURE__ */ a("path", { d: "M6 -2.62268e-07C7.07199 -3.09127e-07 8.1244 0.287201 9.04779 0.831735C9.97118 1.37627 10.7318 2.15825 11.2506 3.09635C11.7694 4.03444 12.0274 5.0944 11.9977 6.16598C11.968 7.23756 11.6518 8.28163 11.082 9.1896C10.5121 10.0976 9.70938 10.8363 8.75729 11.3289C7.8052 11.8215 6.73851 12.0501 5.66816 11.9908C4.59781 11.9315 3.56289 11.5866 2.67104 10.9918C1.77918 10.397 1.06295 9.57417 0.596846 8.60882L2.11272 7.8769C2.44806 8.57142 2.96334 9.16342 3.60499 9.59133C4.24663 10.0192 4.9912 10.2674 5.76126 10.3101C6.53132 10.3527 7.29874 10.1883 7.98372 9.83387C8.6687 9.47945 9.24622 8.94798 9.65621 8.29474C10.0662 7.64151 10.2937 6.89036 10.315 6.11941C10.3364 5.34847 10.1508 4.58589 9.77752 3.91098C9.40429 3.23607 8.85705 2.67347 8.19272 2.28171C7.52839 1.88995 6.77124 1.68332 6 1.68332L6 -2.62268e-07Z" })
  }
);
var ba = /* @__PURE__ */ ((e) => (e.PRIMARY = "primary", e.SECONDARY = "secondary", e.DARK = "dark", e))(ba || {}), U = /* @__PURE__ */ ((e) => (e.STANDARD = "standard", e.MEDIUM = "medium", e.SMALL = "small", e.EXTRA_SMALL = "extraSmall", e))(U || {}), ct = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.PILL = "pill", e.ACTION = "action", e))(ct || {}), ne = /* @__PURE__ */ ((e) => (e.LOADING = "loading", e.DISABLED = "disabled", e))(ne || {});
const Ce = {
  [U.STANDARD]: 20,
  [U.MEDIUM]: 18,
  [U.SMALL]: 16,
  [U.EXTRA_SMALL]: 12
}, Ye = {
  [U.STANDARD]: 20,
  [U.MEDIUM]: 16,
  [U.SMALL]: 12,
  [U.EXTRA_SMALL]: 12
}, pt = (e) => e in Ce ? Ce[e] : Ce[U.STANDARD], ut = (e) => e in Ce ? Ye[e] : Ye[U.STANDARD], Je = (e) => e === ne.DISABLED ? we.neutral.dark_45 : we.neutral.dark_10;
var mt = w({ defaultClassName: "_1hhl8y01 _1hhl8y00", variantClassNames: { size: { standard: "_1hhl8y02", medium: "_1hhl8y03", small: "_1hhl8y04", extraSmall: "_1hhl8y05" }, variant: { default: "_1hhl8y06", pill: "_1hhl8y07", action: "_1hhl8y08" }, color: { primary: "_1hhl8y09", secondary: "_1hhl8y0a", dark: "_1hhl8y0b" }, disabled: { true: "_1hhl8y0c" } }, defaultVariants: { size: "standard", color: "primary", variant: "default" }, compoundVariants: [] });
const ht = ({
  dataTestId: e = "button",
  text: r,
  variant: t,
  size: A,
  status: n,
  startIcon: s,
  endIcon: o,
  color: i,
  startIconColor: c,
  endIconColor: l,
  ...d
}) => {
  const p = c ?? Je(n), u = l ?? Je(n), m = pt(A), v = n === ne.LOADING, y = ut(A);
  return /* @__PURE__ */ a(
    le,
    {
      ...d,
      "aria-label": r,
      className: mt({
        size: A,
        variant: t,
        color: i || ba.PRIMARY,
        disabled: n === ne.DISABLED
      }),
      "data-testid": e,
      disabled: n && [ne.DISABLED, ne.LOADING].includes(n),
      children: v ? /* @__PURE__ */ a(Ea, { backgroundColor: we.neutral.dark_00, height: y, width: y }) : /* @__PURE__ */ b(ma, { children: [
        s && /* @__PURE__ */ a(T, { color: p, height: m, type: s, width: m }),
        r,
        o && /* @__PURE__ */ a(T, { color: u, height: 12, type: o, width: 12 })
      ] })
    }
  );
};
var Te = "var(--_1o5o5be0)";
const vt = (e) => {
  const { category: r, offset: t } = e, A = Z.layers[r];
  if (typeof t == "number" && t < 0)
    throw new Error("Offset must be a positive number as it's a modifier relative to the minimum layer value");
  return {
    // ensure z-index is never higher than the maximum layer value
    zIndex: `min(${A.max}, max(${A.min}, calc(${A.min} + ${Ja(Te, typeof t == "number" ? String(t) : "0")})))`
  };
};
var gt = { 5: "dfee5x0" };
const Ao = (e) => gt[e.level];
var no = Ka({ conditions: { defaultCondition: "xs", conditionNames: ["xs", "sm", "md", "lg", "xl"], responsiveArray: void 0 }, styles: {} }), ue = /* @__PURE__ */ ((e) => (e.NORMAL = "normal", e.SMALL = "small", e))(ue || {}), Ee = /* @__PURE__ */ ((e) => (e.PRIMARY = "primary", e.SECONDARY = "secondary", e))(Ee || {}), se = /* @__PURE__ */ ((e) => (e.LEFT = "left", e.RIGHT = "right", e))(se || {}), ce = /* @__PURE__ */ ((e) => (e.SELECTION = "selection", e.NAVIGATION = "navigation", e))(ce || {});
const Ia = Ve({
  defaultPlacement: void 0,
  onClickItem: () => {
  }
}), Ct = () => ye(Ia);
var Le = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.SELECTED = "selected", e.ERROR = "error", e.DISABLED = "disabled", e))(Le || {}), Ke = "var(--_6ktmkg0)", ft = "var(--_6ktmkg1)", kt = "_6ktmkg2", Et = "_6ktmkg3", bt = "_6ktmkg4", It = "_6ktmkg5", yt = "_6ktmkg6", Rt = w({ defaultClassName: "_6ktmkga _6ktmkg7", variantClassNames: { status: { default: "_6ktmkgb", selected: "_6ktmkgc", error: "_6ktmkgd", disabled: "_6ktmkge" }, variant: { primary: "_6ktmkgf _6ktmkg8", secondary: "_6ktmkgg _6ktmkg9" }, size: { normal: "_6ktmkgh", small: "_6ktmkgi" }, hasSubMenu: { true: "_6ktmkgj" } }, defaultVariants: {}, compoundVariants: [[{ status: "default", variant: "secondary" }, "_6ktmkgk"]] }), Nt = w({ defaultClassName: "_6ktmkgl", variantClassNames: { placement: { left: "_6ktmkgm", right: "_6ktmkgn" }, hidden: { true: "_6ktmkgo", false: "_6ktmkgp" } }, defaultVariants: {}, compoundVariants: [] });
const St = ({
  icon: e,
  id: r,
  text: t,
  size: A,
  subMenu: n,
  status: s = Le.DEFAULT,
  MenuComponent: o,
  variant: i = Ee.PRIMARY
}) => {
  const c = F(null), l = F(null), [d, p] = X(!1), [u, m] = X(void 0), { defaultPlacement: v, onClickItem: y } = Ct();
  fa({
    elementRef: c,
    onClickAway: () => p(!1)
  }), M(() => {
    if (!d) m(void 0);
    else if (l.current) {
      const { left: g, width: C } = l.current.getBoundingClientRect(), k = document.body.clientWidth < g + C, E = g < 0;
      v === se.LEFT && E ? m(se.RIGHT) : v === se.RIGHT && k ? m(se.LEFT) : m(v);
    }
  }, [d, v]);
  const N = () => {
    const g = n?.items.length ? ce.NAVIGATION : ce.SELECTION;
    g === ce.NAVIGATION && p((C) => !C), y?.(r, g);
  }, f = !!n?.items.length;
  return /* @__PURE__ */ b("li", { className: yt, ref: c, children: [
    /* @__PURE__ */ b(le, { className: Rt({ size: A, status: s, variant: i, hasSubMenu: f }), onClick: N, children: [
      /* @__PURE__ */ b("div", { className: kt, children: [
        e && /* @__PURE__ */ a(T, { color: Ke, type: e, width: 16 }),
        /* @__PURE__ */ a("span", { className: Et, children: t })
      ] }),
      f && /* @__PURE__ */ b("div", { className: bt, children: [
        n.label && /* @__PURE__ */ a("span", { className: It, children: n.label }),
        /* @__PURE__ */ a(T, { color: ft, type: d ? h.ARROW_LEFT : h.ARROW_RIGHT, width: 16 })
      ] }),
      s === Le.SELECTED && !f && /* @__PURE__ */ a(T, { color: Ke, type: h.CHECK, width: 12 })
    ] }),
    d && f && /* @__PURE__ */ a("div", { className: Nt({ placement: u ?? v, hidden: !u }), ref: l, children: /* @__PURE__ */ a(o, { ...n, defaultPlacement: u ?? v, size: ue.SMALL, variant: Ee.SECONDARY }) })
  ] });
};
var Dt = "var(--_1u8ua3i0)", Ht = w({ defaultClassName: "_1u8ua3i1", variantClassNames: { variant: { primary: "_1u8ua3i2", secondary: "_1u8ua3i3" }, placement: { left: "_1u8ua3i4", right: "_1u8ua3i5" } }, defaultVariants: {}, compoundVariants: [] }), Ot = w({ defaultClassName: "_1u8ua3i6", variantClassNames: { hasOverflow: { true: "_1u8ua3i7" } }, defaultVariants: {}, compoundVariants: [] });
const wt = (e = ue.NORMAL) => e === ue.NORMAL ? 32 : 28, ya = ({ items: e, size: r, variant: t, defaultPlacement: A, layerOffset: n, maxItemsWithoutScroll: s }) => {
  const o = !!s;
  return /* @__PURE__ */ a(
    "div",
    {
      className: Ht({ variant: t, placement: A }),
      style: V({ [Te]: typeof n == "number" ? String(n) : null }),
      children: /* @__PURE__ */ a(
        "ul",
        {
          className: Ot({ hasOverflow: o }),
          style: V({
            [Dt]: o ? `${s * wt(r)}px` : void 0
          }),
          children: e.map((i) => /* @__PURE__ */ a(St, { ...i, MenuComponent: ya, size: r, variant: t }, i.id))
        }
      )
    }
  );
}, Lt = ({ children: e, defaultPlacement: r, onClickItem: t }) => /* @__PURE__ */ a(Ia.Provider, { value: { defaultPlacement: r, onClickItem: t }, children: e }), Qt = ({
  size: e = ue.NORMAL,
  onClickItem: r,
  items: t,
  variant: A = Ee.PRIMARY,
  defaultPlacement: n = se.RIGHT,
  layerOffset: s,
  maxItemsWithoutScroll: o
}) => /* @__PURE__ */ a(Lt, { defaultPlacement: n, onClickItem: r, children: /* @__PURE__ */ a(ya, { items: t, layerOffset: s, maxItemsWithoutScroll: o, size: e, variant: A }) });
var Ra = /* @__PURE__ */ ((e) => (e.PRIMARY = "primary", e.DARK = "dark", e))(Ra || {}), Na = /* @__PURE__ */ ((e) => (e.LEFT = "left", e.RIGHT = "right", e))(Na || {}), Bt = "q5f06n0", Vt = w({ defaultClassName: "q5f06n1", variantClassNames: { alignMenu: { left: "q5f06n2", right: "q5f06n3" } }, defaultVariants: {}, compoundVariants: [] });
const Tt = ha(
  ({ alignMenu: e = Na.LEFT, buttonProps: r, menuProps: t }, A) => {
    const n = F(null), [s, o] = X(!1);
    va(
      A,
      () => ({
        openMenu: () => o(!0),
        closeMenu: () => o(!1)
      }),
      []
    ), fa({
      elementRef: n,
      onClickAway: () => o(!1)
    });
    const i = (p) => {
      o((u) => !u), r.onClick?.(p);
    }, c = (p, u) => {
      u === ce.SELECTION && o(!1), t?.onClickItem?.(p, u);
    }, l = s ? h.ARROW_UP : h.ARROW_DOWN, d = r.color === Ra.DARK ? Z.colors.main.dark : void 0;
    return /* @__PURE__ */ b("div", { className: Bt, ref: n, children: [
      /* @__PURE__ */ a(ht, { ...r, endIcon: l, endIconColor: d, onClick: i, variant: "action" }),
      s && /* @__PURE__ */ a("div", { className: Vt({ alignMenu: e }), children: /* @__PURE__ */ a(Qt, { ...t, onClickItem: c }) })
    ] });
  }
);
Tt.displayName = "ActionButtonMenu";
var qt = { success: "vt9uvf1 vt9uvf0", warning: "vt9uvf2 vt9uvf0", error: "vt9uvf3 vt9uvf0", info: "vt9uvf4 vt9uvf0" };
const so = ({ label: e, variant: r, iconType: t, ...A }) => /* @__PURE__ */ b("div", { className: qt[r], ...A, children: [
  /* @__PURE__ */ a(T, { color: "currentColor", type: t, width: 12 }),
  e
] });
var xt = /* @__PURE__ */ ((e) => (e.SUCCESS = "success", e.WARNING = "warning", e.ERROR = "error", e.INFO = "info", e))(xt || {});
function Sa(e, r = []) {
  const t = F(e);
  return M(() => {
    t.current = e;
  }, [e, ...r]), j((...A) => t.current(...A), [t]);
}
const Da = ({ cb: e, deps: r = [], ref: t }) => {
  const A = Sa(e);
  M(() => {
    const n = new window.ResizeObserver(A);
    if (t) {
      const s = typeof t == "function" ? t() : t.current;
      s && n.observe(s);
    }
    return () => {
      n.disconnect();
    };
  }, r);
}, oo = (e) => e.charAt(0).toLowerCase() + e.slice(1), lo = (e) => {
  const r = e.replace(/([A-Z])/g, "-$1").toLowerCase();
  return r.charAt(0) === "-" ? r.slice(1) : r;
}, zt = (e) => typeof e == "string" || typeof e == "number", Mt = (e) => {
  const { key: r } = e;
  return zt(r) ? r : null;
}, Wt = (e, r) => {
  let t = 0;
  return (...A) => {
    const n = Date.now();
    if (n - t >= r)
      return t = n, e(...A);
  };
};
function Pt(e, r, t) {
  const A = e.slice();
  return A.splice(t < 0 ? A.length + t : t, 0, A.splice(r, 1)[0]), A;
}
const qe = () => {
}, io = (e) => Object.keys(e), Xt = (e, r) => {
  const t = Sa(e);
  return ke(() => Wt(t, r), [t, r]);
};
var re = /* @__PURE__ */ ((e) => (e.LEFT = "left", e.RIGHT = "right", e))(re || {}), Ft = "var(--_1p46ue90)", Zt = w({ defaultClassName: "_1p46ue91", variantClassNames: { direction: { left: "_1p46ue92", right: "_1p46ue93" } }, defaultVariants: {}, compoundVariants: [] });
const _e = (e) => {
  const { direction: r, onClick: t } = e, A = r === re.LEFT ? h.ARROW_LEFT : h.ARROW_RIGHT;
  return /* @__PURE__ */ a(
    le,
    {
      "aria-label": `Scroll ${r}`,
      className: Zt({ direction: r }),
      "data-testid": `carousel-arrow-${r}`,
      onClick: t,
      tabIndex: 0,
      type: "button",
      children: /* @__PURE__ */ a(T, { color: Ft, height: 24, type: A, width: 24 })
    }
  );
}, Ha = ({ children: e }) => e;
Ha.displayName = "CarouselItem";
var jt = "var(--_1wxf5y40)", Ut = "_1wxf5y41", Gt = "_1wxf5y42", Yt = "_1wxf5y43";
const co = ha(function({ children: r, onScroll: t, activeItemId: A, gap: n, step: s = 180 }, o) {
  const [i, c] = X(
    0
    /* NONE */
  ), l = F(null), d = F({}), p = j((C, k = "smooth") => {
    l.current instanceof HTMLElement && l.current.scrollTo({ left: C, top: 0, behavior: k });
  }, []), u = j((C) => {
    if (l.current instanceof HTMLElement) {
      const k = d.current[C];
      if (k instanceof HTMLElement) {
        const { scrollLeft: E, clientWidth: H } = l.current, { offsetLeft: Q } = k, z = E + 64, I = E + H - 64;
        Q < z ? p(Q - 64, "smooth") : Q + k.offsetWidth > I && p(Q + k.offsetWidth - H + 64, "smooth");
      }
    }
  }, []);
  M(() => {
    if (typeof A == "string" && l.current instanceof HTMLElement) {
      if (Fe.toArray(r).findIndex((k) => Ze(k) && k.props.id === A) === -1)
        return qe()?.warn(`Carousel: activeItemId "${A}" is invalid.`);
      u(A);
    }
  }, [A, u]);
  const m = j((C) => {
    if (!C) return;
    const { scrollLeft: k, scrollWidth: E, clientWidth: H } = C;
    if (E <= H)
      return c(
        0
        /* NONE */
      );
    k === 0 ? c(
      2
      /* RIGHT */
    ) : window.Math.floor(k + H + 1) >= window.Math.floor(E) ? c(
      1
      /* LEFT */
    ) : c(
      3
      /* BOTH */
    );
  }, []);
  va(o, () => ({
    resetScroll: () => {
      p(0, "instant"), m(l.current);
    }
  }));
  const v = j(
    (C) => (k) => {
      if (typeof t == "function" && t(C, k), l.current instanceof HTMLElement) {
        const { scrollLeft: E } = l.current, H = C === re.LEFT ? window.Math.max(0, E - s) : window.Math.min(E + s, l.current.scrollWidth);
        p(H), m(l.current);
      }
    },
    [m, p, t, s]
  ), y = Xt(m, 10);
  M(() => {
    m(l.current);
  }, [m]);
  const N = j(
    (C) => {
      const [k] = C;
      k && y(k.target);
    },
    [y]
  );
  Da({ cb: N, ref: l, deps: [] });
  const f = i === 1 || i === 3, g = i === 2 || i === 3;
  return /* @__PURE__ */ b("div", { className: Ut, children: [
    f && /* @__PURE__ */ a(_e, { direction: re.LEFT, onClick: v(re.LEFT) }),
    /* @__PURE__ */ a(
      "div",
      {
        className: Gt,
        onScroll: () => m(l.current),
        ref: l,
        role: "list",
        style: V({ [jt]: typeof n == "number" ? `${n}px` : void 0 }),
        children: Fe.map(r, (C, k) => {
          if (Ze(C) && C.type === Ha) {
            const E = C.props.id;
            return /* @__PURE__ */ a(
              "div",
              {
                className: Yt,
                onFocus: () => typeof E == "string" && u(E),
                ref: (H) => {
                  H instanceof HTMLElement && typeof E == "string" && (d.current[E] = H);
                },
                role: "listitem",
                tabIndex: -1,
                children: C
              },
              E ?? Mt(C) ?? k
            );
          }
          return null;
        })
      }
    ),
    g && /* @__PURE__ */ a(_e, { direction: re.RIGHT, onClick: v(re.RIGHT) })
  ] });
});
var Jt = /* @__PURE__ */ ((e) => (e.HISTORICAL = "historical", e))(Jt || {});
const po = Ga(() => import("./Chart-pBmrydy3.js").then((e) => ({ default: e.Chart })));
function Kt(e) {
  return e.node;
}
var fe = /* @__PURE__ */ ((e) => (e.CUSTOM = "custom", e.TITLE = "title", e.TOGGLE_TABS = "toggleTabs", e))(fe || {}), _t = "zqs8nu0";
function $t({ text: e }) {
  return /* @__PURE__ */ a("h3", { className: _t, children: e });
}
var Re = /* @__PURE__ */ ((e) => (e.STANDARD = "standard", e.SMALL = "small", e.MEDIUM = "medium", e))(Re || {}), eA = w({ defaultClassName: "dvduaw0", variantClassNames: { variant: { small: "dvduaw1", medium: "dvduaw2", standard: "dvduaw3" }, isOneOption: { true: "dvduaw4" }, isDisabled: { true: "dvduaw5" } }, defaultVariants: { variant: "standard", isOneOption: !1, isDisabled: !1 }, compoundVariants: [] }), aA = "dvduaw6", $e = w({ defaultClassName: "dvduaw7", variantClassNames: { variant: { standard: "dvduaw8", medium: "dvduaw9", small: "dvduawa" }, isActive: { true: "dvduawb", false: "dvduawc" }, isDisabled: { true: "dvduawd" } }, defaultVariants: {}, compoundVariants: [] }), rA = w({ defaultClassName: "dvduawe", variantClassNames: { isDisabled: { true: "dvduawf", false: "dvduawg" } }, defaultVariants: {}, compoundVariants: [] }), tA = "dvduawh";
const Oa = ({
  isChecked: e = !1,
  isDisabled: r = !1,
  options: t,
  onChange: A,
  variant: n = Re.STANDARD,
  ariaLabel: s,
  dataTestId: o = "sparta-switch",
  ...i
}) => {
  const [c, l] = t, d = t.length === 1 || l === void 0, p = d ? !1 : e, [u, m] = X({}), v = F([]), y = F(!1);
  M(() => {
    if (v.current && !d) {
      const f = p ? 1 : 0, g = v.current[f];
      if (g) {
        const C = g.offsetWidth, k = g.offsetLeft;
        m(
          y.current ? {
            width: C,
            transform: `translateX(${k}px)`
          } : {
            width: C,
            transform: `translateX(${k}px)`,
            transition: "none"
          }
        );
      }
    }
    y.current = !0;
  }, [p, d, n, t]);
  const N = () => {
    !d && !r && A(!p);
  };
  return /* @__PURE__ */ b(
    le,
    {
      "aria-checked": p,
      "aria-label": s,
      className: eA({ variant: n, isOneOption: d, isDisabled: r }),
      "data-testid": o,
      onClick: N,
      role: "switch",
      tabIndex: 0,
      ...i,
      children: [
        /* @__PURE__ */ a(
          "input",
          {
            "aria-checked": p,
            "aria-disabled": r || d,
            "aria-hidden": !0,
            checked: p,
            className: tA,
            disabled: r || d,
            onChange: N,
            type: "checkbox",
            value: p ? l : c
          }
        ),
        /* @__PURE__ */ b("div", { className: aA, children: [
          /* @__PURE__ */ a("span", { className: rA({ isDisabled: r }), style: u }),
          /* @__PURE__ */ a(
            "span",
            {
              className: $e({ variant: n, isActive: !d && !p, isDisabled: r }),
              ref: (f) => v.current[0] = f,
              role: "presentation",
              children: c
            }
          ),
          typeof l == "string" && /* @__PURE__ */ a(
            "span",
            {
              className: $e({ variant: n, isActive: !d && p, isDisabled: r }),
              ref: (f) => v.current[1] = f,
              role: "presentation",
              children: l
            }
          )
        ] })
      ]
    }
  );
}, uo = Oa;
function AA(e) {
  return /* @__PURE__ */ a(Oa, { ...e, variant: Re.SMALL });
}
var nA = "_1xw9ece0";
function sA(e) {
  const { slot: r } = e;
  switch (r.type) {
    case fe.TITLE:
      return /* @__PURE__ */ a($t, { ...r });
    case fe.CUSTOM:
      return /* @__PURE__ */ a(Kt, { ...r });
    case fe.TOGGLE_TABS:
      return /* @__PURE__ */ a(AA, { ...r });
    default:
      throw new Error(`[Widget] Invalid slot type: ${r.type}`);
  }
}
function ea(e) {
  const { slots: r } = e;
  return /* @__PURE__ */ a("div", { className: nA, children: r.map((t, A) => /* @__PURE__ */ a(sA, { slot: t }, `${t.type}-${A}`)) });
}
var oA = "_1nkfyby0", lA = "_1nkfyby1", iA = "_1nkfyby2";
function aa(e) {
  const { left: r, right: t, as: A } = e;
  return /* @__PURE__ */ b(A, { className: Y(oA, A === "header" && iA, A === "footer" && lA), children: [
    /* @__PURE__ */ a(ea, { slots: r.slots }),
    /* @__PURE__ */ a(ea, { slots: t.slots })
  ] });
}
var dA = "_1hx5x1e0";
const mo = ({ header: e, footer: r, dataTestId: t, children: A }) => /* @__PURE__ */ b("section", { className: dA, "data-testid": t, children: [
  /* @__PURE__ */ a(aa, { as: "header", ...e }),
  A,
  r && /* @__PURE__ */ a(aa, { as: "footer", ...r })
] });
var cA = "_139tgmb0", pA = "_139tgmb1", uA = "_139tgmb2", mA = "_139tgmb3", hA = "_139tgmb4", vA = "_139tgmb5";
const ho = ({ children: e, openByDefault: r = !0 }) => {
  const t = Ie.Children.count(e);
  return /* @__PURE__ */ b("details", { className: cA, open: r, children: [
    /* @__PURE__ */ b("summary", { "aria-expanded": r, "aria-label": "Toggle chart labels", className: uA, children: [
      /* @__PURE__ */ a("div", { className: mA, children: /* @__PURE__ */ a(T, { color: Z.colors.neutral.dark_35, height: 16, type: h.ARROW_DOWN, width: 16 }) }),
      /* @__PURE__ */ a("span", { className: vA, children: t })
    ] }),
    /* @__PURE__ */ a("div", { className: pA, children: /* @__PURE__ */ a("ul", { className: hA, children: e }) })
  ] });
};
var gA = "_1ekhu8c0", CA = { default: "_1ekhu8c1 _1ekhu8c0", small: "_1ekhu8c2 _1ekhu8c0" }, fA = "_1ekhu8c3", kA = { default: "_1ekhu8c4 _1ekhu8c0", small: "_1ekhu8c5 _1ekhu8c0" };
const EA = ({ id: e, size: r, label: t, colorLine: A, value: n, showCustomIcon: s, isLoading: o }) => (
  // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- navigation with keyboard
  /* @__PURE__ */ b("li", { className: gA, id: e, tabIndex: 0, children: [
    /* @__PURE__ */ a("div", { className: CA[r], children: t }),
    s && /* @__PURE__ */ a("div", { className: fA, children: /* @__PURE__ */ a(T, { "data-testid": "person-icon", height: 10, type: h.PERSON, width: 10 }) }),
    /* @__PURE__ */ a(T, { color: A, "data-testid": "linear-scale-icon", height: 16, type: h.LINEAR_SCALE, width: 16 }),
    n && !o && /* @__PURE__ */ a("div", { className: kA[r], children: n }),
    o && /* @__PURE__ */ a(Ea, { "data-testid": "loading-icon" })
  ] })
);
var bA = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.SMALL = "small", e))(bA || {});
const vo = ({ size: e, title: r, labels: t }) => /* @__PURE__ */ b("li", { children: [
  r,
  /* @__PURE__ */ a("div", { children: /* @__PURE__ */ a("ul", { children: t.map((A) => /* @__PURE__ */ a(EA, { size: e, ...A }, A.id)) }) })
] });
var IA = "_75coan1";
const yA = () => /* @__PURE__ */ a("span", { "aria-label": "Loading", "aria-live": "polite", className: IA, role: "status" });
var wa = /* @__PURE__ */ ((e) => (e.PRIMARY = "primary", e.SECONDARY = "secondary", e))(wa || {}), RA = { primary: "_1mrc6hp1 _1mrc6hp0", secondary: "_1mrc6hp2 _1mrc6hp0" }, NA = "_1mrc6hp3";
const go = ({ message: e, variant: r, ...t }) => /* @__PURE__ */ b("div", { className: RA[r ?? wa.PRIMARY], "data-testid": "sparta-loading-box", ...t, children: [
  /* @__PURE__ */ a("p", { className: NA, children: e }),
  /* @__PURE__ */ a(yA, {})
] });
var La = /* @__PURE__ */ ((e) => (e.ALERT = "alert", e.INFO = "info", e.SUCCESS = "success", e.WARN = "warn", e.ERROR = "error", e))(La || {}), SA = { alert: "_1ud8a5f1 _1ud8a5f0", info: "_1ud8a5f2 _1ud8a5f0", success: "_1ud8a5f3 _1ud8a5f0", warn: "_1ud8a5f4 _1ud8a5f0", error: "_1ud8a5f5 _1ud8a5f0" }, DA = { alert: { type: "warningAmber", color: "var(--sparta-components-colors-feedback_alert-principal)" }, info: { type: "info", color: "var(--sparta-components-colors-main-primary)" }, success: { type: "check", circled: !0, color: "var(--sparta-components-colors-feedback_success-principal)" }, warn: { type: "warningAmber", color: "var(--sparta-components-colors-feedback_warning-principal)" }, error: { type: "report", color: "var(--sparta-components-colors-feedback_error-principal)" } }, HA = "_1ud8a5f6";
const Co = ({ type: e = La.INFO, message: r }) => /* @__PURE__ */ b("div", { className: SA[e], children: [
  /* @__PURE__ */ a(T, { ...DA[e], height: 16, width: 16 }),
  /* @__PURE__ */ a("div", { className: HA, children: r })
] });
var be = /* @__PURE__ */ ((e) => (e.STANDARD = "STANDARD", e.MEDIUM = "MEDIUM", e))(be || {});
const Oe = {
  [be.STANDARD]: 24,
  [be.MEDIUM]: 16
}, OA = (e) => e in Oe ? Oe[e] : Oe[be.STANDARD];
var wA = w({ defaultClassName: "x3hw7k1 x3hw7k0", variantClassNames: { size: { STANDARD: "x3hw7k2", MEDIUM: "x3hw7k3" }, defaultVariants: { size: "x3hw7k4 STANDARD" } }, defaultVariants: {}, compoundVariants: [] }), LA = "x3hw7k5", QA = w({ defaultClassName: "x3hw7k7 x3hw7k6", variantClassNames: { size: { STANDARD: "x3hw7k8", MEDIUM: "x3hw7k9" } }, defaultVariants: { size: "STANDARD" }, compoundVariants: [] }), BA = w({ defaultClassName: "x3hw7kb x3hw7ka", variantClassNames: { size: { STANDARD: "x3hw7kc", MEDIUM: "x3hw7kd" } }, defaultVariants: { size: "STANDARD" }, compoundVariants: [] });
const fo = ({ icon: e, size: r, title: t, description: A }) => {
  const n = OA(r);
  return /* @__PURE__ */ a("div", { className: wA({ size: r }), children: /* @__PURE__ */ b("div", { className: LA, "data-testid": "sparta-overlay-message", children: [
    /* @__PURE__ */ a(T, { color: e?.color, "data-testid": "sparta-overlay-message-icon", height: n, type: e.type, width: n }),
    /* @__PURE__ */ b("div", { children: [
      /* @__PURE__ */ a("div", { className: QA({ size: r }), children: t }),
      A && /* @__PURE__ */ a("div", { className: BA({ size: r }), children: A })
    ] })
  ] }) });
};
var VA = w({ defaultClassName: "_1387wag0", variantClassNames: { blink: { true: "_1387wag1", false: "_1387wag2" } }, defaultVariants: { blink: !1 }, compoundVariants: [] });
const ko = ({ width: e = ka, round: r = !1, blink: t = !1 }) => /* @__PURE__ */ a("div", { className: VA({ blink: t }), "data-testid": "sparta-icon-skeleton", children: /* @__PURE__ */ a(
  T,
  {
    color: Z.colors.neutral_blue.dark_45,
    "data-testid": `icon-skeleton-${r ? "round" : "rect"}`,
    type: r ? h.DOT : h.RECTANGULAR_SKELETON,
    width: e
  }
) });
var TA = w({ defaultClassName: "_11unsc90", variantClassNames: { variant: { small: "_11unsc91", medium: "_11unsc92", standard: "_11unsc93" } }, defaultVariants: { variant: "standard" }, compoundVariants: [] }), qA = w({ defaultClassName: "_11unsc94", variantClassNames: { variant: { small: "_11unsc95", medium: "_11unsc96", standard: "_11unsc97" }, blink: { true: "_11unsc98", false: "_11unsc99" } }, defaultVariants: {}, compoundVariants: [] });
const xA = ({ variant: e = Re.STANDARD, blink: r = !1 }) => /* @__PURE__ */ a("div", { className: TA({ variant: e }), "data-testid": "sparta-switch-skeleton", children: /* @__PURE__ */ a("div", { className: qA({ variant: e, blink: r }) }) }), Eo = xA, ra = {
  family: "Open Sans, serif",
  weight: {
    bold: "700",
    semibold: "600",
    regular: "400"
  },
  sizes: {
    h1: {
      fontSize: "34px",
      lineHeight: "46px"
    },
    h2: {
      fontSize: "28px",
      lineHeight: "38px"
    },
    h3: {
      fontSize: "22px",
      lineHeight: "30px"
    },
    h4: {
      fontSize: "18px",
      lineHeight: "25px"
    },
    body0: {
      fontSize: "16px",
      lineHeight: "24px"
    },
    body1: {
      fontSize: "14px",
      lineHeight: "19px"
    },
    body2: {
      fontSize: "12px",
      lineHeight: "16px"
    },
    body3: {
      fontSize: "11px",
      lineHeight: "15px"
    },
    body4: {
      fontSize: "10px",
      lineHeight: "14px"
    },
    body5: {
      fontSize: "9px",
      lineHeight: "12px"
    }
  }
};
var zA = "var(--_1hb24nr0)", MA = "var(--_1hb24nr1)", WA = "_1hb24nr2", PA = "var(--_1hb24nr3)", XA = "var(--_1hb24nr4)", FA = w({ defaultClassName: "_1hb24nr5", variantClassNames: { blink: { true: "_1hb24nr6", false: "_1hb24nr7" } }, defaultVariants: {}, compoundVariants: [] });
const xe = ({ size: e, width: r = "100%", backgroundColor: t = "inherit", blink: A = !1 }) => /* @__PURE__ */ a(
  "div",
  {
    className: WA,
    "data-testid": "sparta-text-skeleton-container",
    style: V({
      [zA]: r,
      [MA]: ra.sizes[e]?.lineHeight
    }),
    children: /* @__PURE__ */ a(
      "div",
      {
        className: FA({ blink: A }),
        "data-testid": "sparta-text-skeleton",
        style: V({
          [PA]: ra.sizes[e]?.fontSize,
          [XA]: t
        })
      }
    )
  }
);
var Qa = "var(--eqjl7w0)", ZA = "eqjl7w2", jA = "eqjl7w3", UA = "eqjl7w4", Ba = { standard: "eqjl7w5 eqjl7w1", medium: "eqjl7w6 eqjl7w1", small: "eqjl7w7 eqjl7w1" };
const GA = ({ size: e, blink: r, fixedCellWidth: t, variant: A }) => /* @__PURE__ */ a(
  "td",
  {
    className: Ba[A],
    style: V({ [Qa]: t ? `${t}px` : "auto" }),
    children: /* @__PURE__ */ a(xe, { backgroundColor: Z.colors.neutral_blue.dark_70, blink: r, size: e, width: "100%" })
  }
), YA = ({ size: e, blink: r, fixedCellWidth: t, variant: A }) => /* @__PURE__ */ a(
  "th",
  {
    className: Ba[A],
    style: V({ [Qa]: t ? `${t}px` : "auto" }),
    children: /* @__PURE__ */ a(xe, { backgroundColor: Z.colors.neutral_blue.dark_45, blink: r, size: e, width: "100%" })
  }
);
var pe = /* @__PURE__ */ ((e) => (e.SMALL = "small", e.STANDARD = "standard", e.MEDIUM = "medium", e))(pe || {});
const JA = {
  [pe.STANDARD]: ge.BODY3,
  [pe.MEDIUM]: ge.BODY4,
  [pe.SMALL]: ge.BODY5
}, bo = ({
  columns: e,
  rows: r,
  variant: t = pe.STANDARD,
  blink: A = !0,
  headerWithLine: n = !1,
  cellWithLine: s = !1,
  fixedCellWidth: o
}) => {
  const i = JA[t];
  return /* @__PURE__ */ b("table", { className: ZA, "data-testid": "sparta-table-skeleton", children: [
    /* @__PURE__ */ a("thead", { children: /* @__PURE__ */ a("tr", { className: n ? jA : void 0, children: Array.from({ length: e }, (c, l) => /* @__PURE__ */ a(YA, { blink: A, fixedCellWidth: o, size: i, variant: t }, `header-${l}`)) }) }),
    /* @__PURE__ */ a("tbody", { children: Array.from({ length: r - 1 }, (c, l) => /* @__PURE__ */ a("tr", { className: s ? UA : void 0, children: Array.from({ length: e }, (d, p) => /* @__PURE__ */ a(GA, { blink: A, fixedCellWidth: o, size: i, variant: t }, `cell-${l}-${p}`)) }, `row-${l}`)) })
  ] });
};
var Ne = /* @__PURE__ */ ((e) => (e.SMALL = "small", e.STANDARD = "standard", e))(Ne || {}), KA = "var(--_1rkmsu0)", _A = w({ defaultClassName: "_1rkmsu1", variantClassNames: { isDisabled: { true: "_1rkmsu2", false: "_1rkmsu3" }, tabWidth: { auto: "_1rkmsu4", "1fr": "_1rkmsu5" } }, defaultVariants: { tabWidth: "1fr" }, compoundVariants: [] }), $A = w({ defaultClassName: "_1rkmsu7", variantClassNames: { variant: { small: "_1rkmsu8", standard: "_1rkmsu9" }, isActive: { true: "_1rkmsua", false: "_1rkmsub" }, isDisabled: { true: "_1rkmsuc", false: "_1rkmsud" } }, defaultVariants: { isActive: !1, isDisabled: !1 }, compoundVariants: [] });
const en = ({ id: e, label: r, isActive: t, isDisabled: A, variant: n, ...s }) => /* @__PURE__ */ Ya(
  le,
  {
    ...s,
    "aria-controls": e,
    "aria-selected": t,
    className: $A({ variant: n, isActive: t, isDisabled: A }),
    disabled: A,
    key: e,
    role: "tab",
    tabIndex: 0,
    type: "button"
  },
  r
), Io = ({
  tabs: e,
  onChange: r,
  ariaLabelledBy: t,
  ariaLabel: A,
  dataTestId: n = "sparta-tabs",
  variant: s = Ne.STANDARD,
  activeTabId: o,
  tabWidth: i = "1fr",
  isDisabled: c = !1,
  ...l
}) => {
  const d = e.some((p) => p.id === o);
  return /* @__PURE__ */ a(
    "ul",
    {
      "aria-labelledby": t,
      className: _A({ tabWidth: i, isDisabled: c }),
      "data-testid": n,
      role: "tablist",
      style: V({ [KA]: e?.length.toString() ?? "1" }),
      ...l,
      children: e.map((p, u) => /* @__PURE__ */ a(Ie.Fragment, { children: /* @__PURE__ */ a(
        en,
        {
          ...p,
          isActive: d ? p.id === o : u === 0,
          isDisabled: c,
          onClick: () => r(p.id),
          variant: s
        }
      ) }, p.id))
    }
  );
};
var an = w({ defaultClassName: "_46vt5p0", variantClassNames: { variant: { small: "_46vt5p1", standard: "_46vt5p2" } }, defaultVariants: {}, compoundVariants: [] }), rn = w({ defaultClassName: "_46vt5p3", variantClassNames: { variant: { small: "_46vt5p4", standard: "_46vt5p5" } }, defaultVariants: {}, compoundVariants: [] }), tn = w({ defaultClassName: "_46vt5p6", variantClassNames: { variant: { standard: "_46vt5p7", small: "_46vt5p8" } }, defaultVariants: {}, compoundVariants: [] }), An = "_46vt5p9";
const nn = ({ variant: e }) => /* @__PURE__ */ a("li", { className: tn({ variant: e }), children: /* @__PURE__ */ a("span", { className: An }) }), sn = ({ blink: e, variant: r }) => {
  const t = r === Ne.SMALL ? "body3" : "body2";
  return /* @__PURE__ */ a("li", { className: rn({ variant: r }), children: /* @__PURE__ */ a(xe, { backgroundColor: Z.colors.neutral_blue.dark_45, blink: e, size: t }) });
}, yo = ({ quantity: e, variant: r = Ne.STANDARD, blink: t = !1 }) => /* @__PURE__ */ a("ul", { className: an({ variant: r }), "data-testid": "sparta-tabs-skeleton", children: Array.from(Array(e), (A, n) => /* @__PURE__ */ b(Ie.Fragment, { children: [
  /* @__PURE__ */ a(sn, { blink: t, variant: r }),
  e > 1 && n !== e - 1 && /* @__PURE__ */ a(nn, { variant: r })
] }, n)) });
var $ = /* @__PURE__ */ ((e) => (e.STANDARD = "standard", e.MEDIUM = "medium", e.SMALL = "small", e))($ || {}), Va = /* @__PURE__ */ ((e) => (e.STANDARD = "standard", e.LIGHT = "light", e))(Va || {}), me = /* @__PURE__ */ ((e) => (e.PRIMARY = "primary", e.SECONDARY = "secondary", e.PRIMARY_TOP = "primaryTop", e))(me || {});
function oe(e) {
  return e.rows !== void 0;
}
const Ta = (e, r, t) => {
  let A = r, n = r;
  return e === "left" ? A = r * t : e === "right" && (n = r * t), {
    paddingTop: r,
    paddingRight: n,
    paddingBottom: r,
    paddingLeft: A
  };
}, on = (e, r, t = []) => {
  for (const A of r) {
    if (!oe(A)) {
      if (Object.values(A).some((n) => typeof n == "object" && n.key === e))
        return [...t];
      continue;
    }
    if (A.rows)
      for (const n of A.rows) {
        const s = on(e, [n], [...t, A.key]);
        if (s) return s;
      }
  }
  return null;
}, ze = (e, r, t = []) => {
  for (const A of r) {
    const n = [...t, A];
    if (A.columns) {
      const s = ze(e, A.columns, n);
      if (s) return s;
    } else if (A.key === e || n.some((s) => s.key === e))
      return n;
  }
  return null;
}, ln = (e, r) => {
  for (const t of e)
    if (oe(t)) {
      const A = ln(t.rows, r);
      if (A)
        return A;
    } else {
      const A = Object.entries(t);
      for (const [n, s] of A)
        if (typeof s == "object" && s.key === r)
          return n;
    }
  return null;
}, ta = (e = $.STANDARD) => ({
  [$.STANDARD]: 8,
  [$.MEDIUM]: 4,
  [$.SMALL]: 2
})[e], qa = (e) => {
  const r = e.rows[0];
  return oe(r) ? qa(r) : r;
}, he = (e) => e !== null, Me = (e) => e.reduce((r, t) => t.columns ? [...r, ...Me(t.columns)] : [...r, t.key], []), dn = (e, r, t) => {
  if (!e?.columnKey) return !1;
  const A = ze(e.columnKey, r);
  return A?.some((o) => o.isHeader) ? !1 : (A?.map((o) => o.key) ?? []).some((o) => t === o);
}, cn = ({
  columns: e,
  isHoverable: r,
  horizontalGrid: t,
  verticalGrid: A
}) => {
  const [n, s] = X(null);
  return {
    handleHoverOverCellMouseEnter: (d, p, u) => {
      const m = n?.rowKey !== u || p !== n?.columnKey;
      !d && m ? s((v) => ({
        ...v,
        columnKey: (p || v?.columnKey) ?? null,
        rowKey: (u || v?.rowKey) ?? null
      })) : d && s(null);
    },
    handleHoverOverCellMouseLeave: () => s(null),
    isCellVerticallyHovered: (d) => r && he(A) && dn(n, e, d),
    isRowHovered: (d) => r === !0 && he(t) && n?.rowKey === d
  };
}, xa = Ve(void 0), pn = ({
  children: e,
  isPivotal: r = !1,
  isHoverable: t,
  isInteractive: A,
  correctionFactorValue: n = 1,
  columns: s,
  customCellComponents: o,
  rows: i,
  selectedCellId: c,
  headerSizeVariant: l,
  bodySizeVariant: d,
  horizontalGrid: p,
  verticalGrid: u,
  onCellClick: m,
  initialOpenRows: v = [],
  handleNestedRowsOpening: y,
  colorVariant: N
}) => {
  const [f, g] = X(c ?? void 0), [C, k] = X(void 0), [E, H] = X(null), [Q, z] = X(v), I = F(i), S = F(s);
  M(() => {
    I.current = i, S.current = s;
  }), M(() => {
    c !== void 0 && g(c ?? void 0);
  }, [c]);
  const D = (q) => {
    c === void 0 && g(q);
  }, L = ta(d), R = ta(l), { handleHoverOverCellMouseEnter: B, handleHoverOverCellMouseLeave: W, isCellVerticallyHovered: ae, isRowHovered: P } = cn({
    columns: s,
    isHoverable: t,
    horizontalGrid: p,
    verticalGrid: u
  }), te = (q) => {
    const x = Q.includes(q);
    z((Ae) => x ? Ae.filter((K) => K !== q) : [...Ae, q]), y && y(q, !x);
  }, J = (q) => Q.includes(q);
  return /* @__PURE__ */ a(
    xa.Provider,
    {
      value: {
        state: {
          columns: s,
          customCellComponents: o,
          leftColumnsToAddInHeader: C,
          selectedCellId: f,
          isPivotal: r,
          isInteractive: A,
          isHoverable: t,
          bodyPaddingSize: L,
          headerPaddingSize: R,
          correctionFactorValue: n,
          clickedRowKey: E,
          headerSizeVariant: l,
          bodySizeVariant: d,
          horizontalGrid: p,
          verticalGrid: u,
          colorVariant: N
        },
        actions: {
          setLeftColumnsToAddInHeader: k,
          handleCellSelection: D,
          setClickedRowKey: H,
          handleHoverOverCellMouseEnter: B,
          handleHoverOverCellMouseLeave: W,
          isCellVerticallyHovered: ae,
          isRowHovered: P,
          onToggleRow: te,
          onCellClick: m,
          isNestedRowOpen: J
        }
      },
      children: e
    }
  );
}, ee = () => {
  const e = ye(xa);
  if (!e)
    throw new Error("useTableContext must be used within a TableProvider");
  return e;
}, We = (e, r, t) => {
  const A = F(null), n = j(() => {
    if (!e || !r || !A.current) return;
    const c = A.current.closest("table"), l = t ? CSS.escape(t) : "";
    return l && c?.querySelector(`#${l}`)?.previousElementSibling || null;
  }, [t]), s = j((c) => {
    A.current && (A.current.style.position = "sticky", A.current.style.left = `${c}px`, A.current.style.zIndex = vt({ category: G.BASE, offset: 5 }).zIndex, A.current.style.pointerEvents = "auto");
  }, []), o = () => {
    if (!A?.current) return;
    const l = A.current.closest("table")?.getBoundingClientRect();
    A.current.style.left = "unset";
    const d = A?.current?.getBoundingClientRect();
    if (!d || !l) return;
    const p = d.left - l.left;
    return p >= 0 ? p : 0;
  }, i = j(
    (c) => {
      const [l] = c;
      if (!l) return;
      const d = l.target, { width: p } = d.getBoundingClientRect();
      s(p);
    },
    [s]
  );
  return Da({ ref: n, cb: i, deps: [n] }), M(() => {
    if (n() === null) {
      const l = o();
      s(l ?? 0);
    }
  }, [n, s]), A;
};
var un = "n519mq1", mn = w({ defaultClassName: "n519mq2", variantClassNames: { colorVariant: { standard: "n519mq3", light: "n519mq4" } }, defaultVariants: { colorVariant: "standard" }, compoundVariants: [] }), hn = "n519mq5", vn = "n519mq6", gn = "n519mq7", Cn = "var(--n519mq9)", fn = "var(--n519mqa)", kn = "var(--n519mqb)", En = "var(--n519mqc)", bn = "var(--n519mqd)", In = "var(--n519mqe)", yn = "var(--n519mqf)", Rn = "var(--n519mqg)", Nn = "var(--n519mqh)", Sn = "var(--n519mqk)", Dn = "n519mql", Hn = "n519mqm", On = "n519mqn n519mq8", wn = "n519mqo", Ln = "n519mqp", Qn = "n519mqq", Bn = w({ defaultClassName: "n519mqr", variantClassNames: { sizeVariant: { standard: "n519mqs", medium: "n519mqt", small: "n519mqu" } }, defaultVariants: { sizeVariant: "standard" }, compoundVariants: [] }), Vn = "n519mqv", Tn = "var(--n519mqw)", qn = "n519mqx", xn = "n519mqy", zn = "var(--n519mqz)", Aa = "var(--n519mq10)", na = "var(--n519mq11)", Mn = "n519mq12", Wn = "n519mq13", Pn = "n519mq14", Xn = "var(--n519mq15)", Fn = "n519mq16", Zn = "var(--n519mq17)", jn = "var(--n519mq18)", Un = "var(--n519mq19)", Gn = "var(--n519mq1a)", Yn = "var(--n519mq1b)", Jn = "var(--n519mq1d)", Kn = "var(--n519mq1e)", _n = "var(--n519mq1f)", $n = "var(--n519mq1g)", es = "var(--n519mq1h)", as = "var(--n519mq1i)", rs = "var(--n519mq1j)", ts = "var(--n519mq1k)", za = "n519mq1l", Ma = "n519mq1m", Pe = w({ defaultClassName: "n519mq1n", variantClassNames: { colorVariant: { standard: "n519mq1o", light: "n519mq1p" } }, defaultVariants: { colorVariant: "standard" }, compoundVariants: [] }), As = "n519mq1q n519mq8", ns = "n519mq1r", ss = "n519mq1s", os = "n519mq1t", ls = "n519mq1u", is = "n519mq1v", ds = "n519mq1w", cs = "n519mq1x", ps = w({ defaultClassName: "n519mq1y", variantClassNames: { sizeVariant: { standard: "n519mq1z", medium: "n519mq20", small: "n519mq21" } }, defaultVariants: { sizeVariant: "standard" }, compoundVariants: [] }), us = "n519mq23", ms = "n519mq24", hs = w({ defaultClassName: "n519mq25", variantClassNames: { positionVariants: { primary: "n519mq26", secondary: "n519mq27", primaryTop: "n519mq28" }, alignment: { right: "n519mq29", left: "n519mq2a", center: "n519mq2b" } }, defaultVariants: { positionVariants: "primary", alignment: "center" }, compoundVariants: [] });
const sa = ({ icon: e, textAlign: r }) => {
  const {
    state: { bodySizeVariant: t }
  } = ee(), A = e.positionVariant === me.PRIMARY_TOP && t !== $.STANDARD ? me.PRIMARY : e.positionVariant;
  return /* @__PURE__ */ a("div", { className: hs({ positionVariants: A, alignment: r }), "data-testid": "cell-icon-container", children: /* @__PURE__ */ a(T, { color: e.color ?? e.fill, type: e.type, width: 12 }) });
}, vs = ({ rowKey: e, cellTheme: r, icon: t, value: A, isSelected: n, isHeader: s, isParentRowWithNestedRows: o }) => {
  const {
    state: { bodyPaddingSize: i, correctionFactorValue: c, bodySizeVariant: l, isHoverable: d },
    actions: { onToggleRow: p, isNestedRowOpen: u }
  } = ee(), { isDisabled: m, secondaryContent: v, secondaryColor: y, backgroundColor: N, backgroundStyles: f, color: g, fontSize: C, fontWeight: k, textAlign: E } = r || {}, { paddingTop: H, paddingRight: Q, paddingBottom: z, paddingLeft: I } = Ta(
    E ?? "center",
    i,
    c
  ), S = () => V({
    [Zn]: N ?? f?.color,
    [Jn]: E,
    [es]: `${H - 1.5}px ${Q - 1}px ${z - 1.5}px ${I - 1}px`
  }), D = () => V({
    [Un]: g,
    [Gn]: C,
    [Yn]: k
  }), L = () => V({
    [Kn]: y
  }), R = Y(ns, {
    [ss]: o,
    [cs]: n,
    [is]: d && !s && !m
  }), B = u(e);
  return /* @__PURE__ */ a("div", { className: R, "data-testid": "body-cell-wrapper", onClick: () => p(e), style: S(), children: /* @__PURE__ */ b("div", { className: ls, children: [
    /* @__PURE__ */ b("div", { className: os, children: [
      /* @__PURE__ */ b("span", { className: ps({ sizeVariant: l }), style: D(), children: [
        A,
        t && t.positionVariant !== me.SECONDARY && /* @__PURE__ */ a(sa, { icon: t, textAlign: E })
      ] }),
      v && /* @__PURE__ */ b("span", { className: us, style: L(), children: [
        v,
        t && t.positionVariant === me.SECONDARY && /* @__PURE__ */ a(sa, { icon: t, textAlign: E })
      ] })
    ] }),
    o && /* @__PURE__ */ a(
      T,
      {
        color: B ? Z.colors.main.primary : void 0,
        height: 16,
        type: B ? h.ARROW_UP : h.ARROW_DOWN,
        width: 16
      }
    )
  ] }) });
}, oa = Z.colors.neutral_blue.dark_73, gs = (e) => {
  if (e)
    return e?.color;
}, Wa = (e) => {
  if (e)
    return `1px solid ${e?.color}`;
}, Cs = ({
  cellKey: e,
  value: r,
  columnKey: t,
  columns: A,
  isOverlay: n = !1,
  isParentRowWithNestedRows: s = !1,
  cellTheme: o,
  rowKey: i,
  icon: c,
  customComponent: l,
  rowBackgroundColor: d,
  isRowSelected: p
}) => {
  const {
    state: { customCellComponents: u, selectedCellId: m, isInteractive: v, isPivotal: y, clickedRowKey: N, horizontalGrid: f, verticalGrid: g, colorVariant: C },
    actions: { handleCellSelection: k, handleHoverOverCellMouseEnter: E, isCellVerticallyHovered: H, setClickedRowKey: Q, isRowHovered: z, onCellClick: I }
  } = ee(), { highlighted: S, isDisabled: D, borderBottom: L } = o || {}, R = ze(t, A)?.[0], B = We(y ?? !1, R?.isHeader, R?.key), W = () => {
    e && k(e);
  }, ae = () => {
    !e || R?.isHeader || D || (N !== i && Q(i), v && W(), I && I(e));
  }, P = !!(e && e === m), te = Y(As, {
    [za]: R?.isHeader,
    [ds]: S,
    [Ma]: p && he(f),
    [Pe({ colorVariant: C })]: H(t) || z(i)
  }), J = () => V({
    [_n]: R?.minWidth,
    [$n]: R?.maxWidth,
    [as]: L || Wa(f),
    [rs]: gs(g),
    [jn]: H(t) ? o?.backgroundStyles?.hoverColor : void 0,
    [ts]: R?.isHeader ? d : void 0
  }), q = ke(() => {
    if (u && l)
      return u[l.type];
  }, [u, l]);
  let x = {};
  return n && (x = {
    visibility: "hidden",
    maxWidth: 0,
    minWidth: 0,
    whiteSpace: "nowrap"
  }), /* @__PURE__ */ a(
    "td",
    {
      className: te,
      "data-cell-key": e,
      "data-cell-selected": v ? P : void 0,
      onClick: ae,
      onMouseEnter: () => E(R?.isHeader, t, i),
      ref: B,
      style: { ...J(), ...x },
      children: q && l?.props ? /* @__PURE__ */ a(q, { cellKey: e, cellTheme: o, columnKey: t, rowKey: i, ...l.props }) : /* @__PURE__ */ a(
        vs,
        {
          cellTheme: o,
          icon: c,
          isHeader: R?.isHeader,
          isParentRowWithNestedRows: s,
          isSelected: P,
          rowKey: i,
          value: r
        }
      )
    },
    e
  );
}, fs = {
  isColumnSortable: () => !1,
  areRowsSortable: !1,
  isDragging: !1
}, Pa = Ve(fs), _ = (e) => {
  if (e?.current)
    return e.current;
}, la = (e, r, t) => {
  const A = e.findIndex(({ key: i }) => i === r.rootKey), n = e.findIndex(({ key: i }) => i === t.rootKey), s = e[A];
  return [
    {
      sorteredItems: Pt(e, A, n),
      draggedItem: s,
      oldOrder: A,
      newOrder: n,
      active: { key: r.key, rootKey: r.rootKey },
      over: { key: t.key, rootKey: t.rootKey }
    }
  ];
}, Qe = {
  border: `1px solid ${Z.colors.neutral_blue.dark_35}`,
  backgroundColor: "rgba(23, 27, 38, 0.60)",
  boxShadow: "0px 12.8px 28.8px 0px rgba(0, 0, 0, 0.22), 0px 2.4px 7.2px 0px rgba(0, 0, 0, 0.18)"
};
class ks extends _a {
  static activators = [
    {
      eventName: "onPointerDown",
      handler: (r, t) => {
        const { nativeEvent: A } = r;
        return !A.isPrimary || A.button !== 0 || A.target instanceof Element && A.target.closest("button") ? !1 : (t.onActivation?.({ event: A }), !0);
      }
    }
  ];
}
function Es({
  ColumnOverlay: e,
  RowOverlay: r,
  children: t,
  columns: A,
  rows: n,
  onSortColumns: s,
  onSortRows: o
}) {
  const [i, c] = X(), l = $a(er(ks)), d = () => c(void 0), p = ({ active: N, over: f }) => {
    const { type: g, rootKey: C } = _(N.data) || {}, { type: k, rootKey: E } = _(f?.data) || {};
    return g !== k || C === E;
  }, u = (N) => !!s && !A.find((f) => N === f.key)?.disableSorting, m = () => {
    if (!i) return null;
    const { type: N, draggingColumn: f, draggingRow: g, overlay: C, getElement: k } = i;
    if (N === "column" && f) {
      const E = k?.(), H = E?.closest("thead")?.clientHeight, Q = E?.clientWidth;
      return /* @__PURE__ */ a(
        e,
        {
          columns: [{ ...f, minWidth: Q ? `${Q}px` : void 0 }],
          isOverlay: !0,
          style: {
            height: H,
            ...Qe
          }
        }
      );
    }
    if (N === "row") {
      if (C) return C;
      if (g)
        return /* @__PURE__ */ a(r, { columnKeys: [Me(A)[0] || ""], isOverlay: !0, rows: [g], style: Qe });
    }
    return null;
  }, v = ({ active: N }) => {
    const f = _(N.data);
    f && c({
      ...f,
      draggingColumn: f.type === "column" ? A.find((g) => g.key === f.rootKey) : void 0,
      draggingRow: f.type === "row" ? n.find((g) => g.key === f.rootKey) : void 0
    });
  }, y = ({ active: N, over: f }) => {
    d();
    const g = _(N.data), C = _(f?.data);
    !g || !C || (g.type === "column" ? s?.(...la(A, g, C)) : g.type === "row" && o?.(...la(n, g, C)));
  };
  return /* @__PURE__ */ a(
    Pa.Provider,
    {
      value: {
        isDragging: !!i,
        isColumnSortable: u,
        areRowsSortable: !!o
      },
      children: /* @__PURE__ */ b(
        ar,
        {
          cancelDrop: p,
          collisionDetection: rr,
          onDragAbort: d,
          onDragCancel: d,
          onDragEnd: y,
          onDragStart: v,
          sensors: l,
          children: [
            t,
            /* @__PURE__ */ a(
              tr,
              {
                dropAnimation: null,
                style: {
                  height: "auto",
                  width: "auto",
                  cursor: "grabbing"
                },
                children: m()
              }
            )
          ]
        }
      )
    }
  );
}
const Xa = () => ye(Pa), bs = ({ children: e, id: r, refHandler: t, type: A, style: n, rootKey: s, overlay: o }) => {
  const {
    attributes: { role: i, ...c },
    listeners: l,
    setNodeRef: d,
    isDragging: p,
    active: u
  } = Ar({
    id: r,
    data: {
      type: A,
      key: r,
      rootKey: s,
      getElement: () => t.current,
      overlay: o
    }
  });
  M(() => {
    d(t.current);
  });
  const m = _(u?.data), v = p || m?.rootKey === s, y = {
    ...n,
    cursor: "grab",
    pointerEvents: "auto"
  };
  return v && A === m?.type && (y.opacity = 0.4), ga(e, {
    ...c,
    "aria-label": `${A}--${r}`,
    ...l,
    style: { ...e.props.style, ...y }
  });
}, Is = ({ children: e, id: r, refHandler: t, type: A, style: n, rootKey: s }) => {
  const { setNodeRef: o, isOver: i, active: c, over: l } = nr({
    id: r,
    data: {
      type: A,
      key: r,
      rootKey: s
    }
  });
  M(() => {
    o(t.current);
  });
  const d = _(c?.data), p = _(l?.data), u = i || p?.rootKey === s, m = { ...n };
  return u && d?.type === A && (m.opacity = 0.5, m.backgroundColor = Qe.backgroundColor), d?.type === A && (m.transition = "background-color ease-in 200ms"), ga(e, { style: { ...e.props.style, ...m } });
}, Fa = ({ children: e, isDraggable: r, isDroppable: t, ...A }) => {
  let n = r ? /* @__PURE__ */ a(bs, { ...A, children: e }) : e;
  return n = t ? /* @__PURE__ */ a(Is, { ...A, children: n }) : n, n;
}, ys = ({ cellKey: e, header: r, rowSpan: t, isOverlay: A = !1, rootKey: n = e, rows: s }) => {
  const {
    state: { isPivotal: o, horizontalGrid: i }
  } = ee(), { areRowsSortable: c, isDragging: l } = Xa(), d = We(o ?? !1, !0), { title: p, subtitle: u, minWidth: m, maxWidth: v, draggable: y, titleColor: N } = r || {}, f = (H) => {
    if (!H) return;
    const Q = H[H.length - 1];
    if (Q?.rows)
      return f(Q.rows);
    const z = Object.keys(Q)[0];
    return Q[z]?.borderBottom;
  }, g = () => V({
    [Tn]: f(s) || Wa(i)
  }), C = () => V({
    [zn]: N,
    [Aa]: m,
    [na]: v
  }), k = () => V({
    [Aa]: m,
    [na]: v
  }), E = c && !!r && !y?.disabled && !A;
  return /* @__PURE__ */ a(
    Fa,
    {
      id: y?.key || e,
      isDraggable: E,
      isDroppable: E,
      overlay: y?.overlay,
      refHandler: d,
      rootKey: y?.rootKey || n,
      type: "row",
      children: /* @__PURE__ */ b("th", { className: qn, ref: d, rowSpan: t, style: g(), children: [
        E && !l && !y?.hideIcon && /* @__PURE__ */ a("div", { className: xn, "data-testid": "drag-icon", children: /* @__PURE__ */ a(T, { height: 10, type: h.DRAG, width: 6.5 }) }),
        (r?.title || r?.subtitle) && /* @__PURE__ */ b("div", { className: Mn, children: [
          p && /* @__PURE__ */ a("span", { className: Wn, style: C(), children: p }),
          u && /* @__PURE__ */ a("span", { className: Pn, style: k(), children: u })
        ] })
      ] }, e)
    }
  );
}, ia = ({ columnKeys: e, isOverlay: r = !1, numBodies: t = 1, rows: A, style: n }) => {
  const {
    state: { columns: s, selectedCellId: o, clickedRowKey: i, leftColumnsToAddInHeader: c, horizontalGrid: l, colorVariant: d, isInteractive: p },
    actions: { handleHoverOverCellMouseLeave: u, isRowHovered: m, setLeftColumnsToAddInHeader: v, isNestedRowOpen: y }
  } = ee(), N = j((I) => {
    const S = (D) => "rows" in D && oe(D) ? D.rows.length > 0 ? Math.max(...D.rows.map(S)) + 1 : 1 : 0;
    return Math.max(...I.map(S), 0);
  }, []);
  M(() => {
    const I = N(A);
    v?.(I);
  }, [A, v, N]);
  const f = j((I) => {
    if ("rows" in I && oe(I)) {
      const S = I?.header?.row;
      return I.rows.reduce(
        (D, L) => D + f(L),
        S ? 1 : 0
      );
    }
    return 1;
  }, []), g = (I, S, D) => p === !0 && (I === i || S.some((L) => D[L]?.key === o)), C = (I, S, D, L = !1) => Y(
    m(I) && Pe({ colorVariant: d }),
    g(I, S, D) && he(l) && Ma,
    !L && Fn
  ), k = (I) => V({
    [Xn]: I.backgroundColor
  }), E = (I, S, D, L = !1) => {
    const R = C(I, D, S, L);
    return /* @__PURE__ */ a("tr", { className: R, "data-row-key": I, onMouseLeave: u, style: k(S), children: D.map((B, W) => /* @__PURE__ */ a(
      Cs,
      {
        cellKey: S[B]?.key,
        cellTheme: S[B],
        columnKey: B,
        columns: s,
        customComponent: S[B]?.customComponent,
        icon: S[B]?.icon,
        isOverlay: r,
        isParentRowWithNestedRows: L && W === 0,
        isRowSelected: g(I, D, S),
        rowBackgroundColor: S.backgroundColor,
        rowKey: I,
        value: S[B]?.value
      },
      S[B]?.key
    )) }, I);
  }, H = (I, S, D = "", L) => I.flatMap((R, B) => {
    const W = `${D}${D ? "-" : ""}${R.key || B}`;
    if ("rows" in R && oe(R)) {
      const ae = f(R), P = H(R.rows, S, W, L || R.key), J = `${W}@${P[0].key}`.split("@").pop() ?? "", q = qa(R), x = !!R?.header?.row, Ae = C(J, S, q, x), K = R?.header?.row && E(R.key, R.header.row, S, x), ve = x && y(R?.key), Se = () => x && !ve ? 1 : ae;
      return [/* @__PURE__ */ b(
        "tr",
        {
          className: Ae,
          "data-row-key": x ? R?.key : J,
          onMouseLeave: u,
          style: k(q),
          children: [
            /* @__PURE__ */ a(
              ys,
              {
                cellKey: R.key,
                header: R.header,
                isOverlay: r,
                rootKey: L,
                rowSpan: Se(),
                rows: R.rows
              }
            ),
            K ? K.props.children : P.length > 0 && P[0].props.children
          ]
        },
        x ? R?.key : J
      ), ...K ? ve ? P : [] : P.slice(1)];
    }
    return E(W, R, S);
  }), Q = (I, S = "") => I.flatMap((D, L) => {
    const R = `${S}-${D.key || L}`;
    return E(R, D, Object.keys(D));
  }), z = (I) => {
    const S = Math.ceil(I.length / t);
    return Array.from({ length: t }, (D, L) => {
      const R = I.slice(L * S, (L + 1) * S);
      return /* @__PURE__ */ a("tbody", { className: hn, children: Q(R, `body-${L}`) }, L);
    });
  };
  return c === void 0 ? null : t > 1 ? /* @__PURE__ */ a("div", { className: vn, children: z(A) }) : /* @__PURE__ */ a("tbody", { style: n, children: H(A, e) });
}, Za = (e) => e.columns ? e.columns.reduce((r, t) => r + Za(t), 0) : 1, ja = (e) => Math.max(...e.map((r) => r.columns ? 1 + ja(r.columns) : 1));
var Rs = "_187d4ct1", Ns = "_187d4ct2", Ss = "_187d4ct3", Ds = "_187d4ct4";
const Hs = ({ arrowRef: e, context: r, message: t, title: A }) => t ? /* @__PURE__ */ b("div", { className: Rs, children: [
  /* @__PURE__ */ a(sr, { className: Ds, context: r, height: 8, ref: e, width: 14 }),
  A && /* @__PURE__ */ a("span", { className: Ns, children: A }),
  /* @__PURE__ */ a("span", { className: Ss, children: t })
] }) : null;
var Ua = /* @__PURE__ */ ((e) => (e.STANDARD = "standard", e.SMALL = "small", e.EXTRA_SMALL = "extraSmall", e))(Ua || {}), Os = w({ defaultClassName: "a2rqsb1 a2rqsb0", variantClassNames: { size: { extraSmall: "a2rqsb2", small: "a2rqsb3", standard: "a2rqsb4" } }, defaultVariants: {}, compoundVariants: [] }), ws = "a2rqsb5", Ls = "a2rqsb6", Qs = "a2rqsb7", Bs = w({ defaultClassName: "a2rqsb9 a2rqsb8", variantClassNames: { size: { extraSmall: "a2rqsba", small: "a2rqsbb", standard: "a2rqsbc" } }, defaultVariants: {}, compoundVariants: [] }), Vs = "a2rqsbd", Ts = "a2rqsbe", qs = "a2rqsbf";
const xs = ({ data: e, tableSize: r = Ua.STANDARD }) => {
  const t = (o, i) => /* @__PURE__ */ a("div", { className: Y(Vs, i), style: { gridTemplateColumns: `1fr repeat(${o.length - 1}, auto)` }, children: o.map((c, l) => /* @__PURE__ */ a("span", { className: Y(l ? qs : Ts), children: c }, l)) }), A = (o) => /* @__PURE__ */ b("div", { className: Bs({ size: r }), children: [
    t(o.values, Qs),
    o.subItems?.map((i, c) => /* @__PURE__ */ a(De, { children: t(i) }, c))
  ] }), n = (o) => o.map((i, c) => /* @__PURE__ */ a(De, { children: i.subItems?.length ? A(i) : t(i.values, Ls) }, c)), s = () => e?.map((o, i) => /* @__PURE__ */ b(De, { children: [
    !!o.titles?.length && t(o.titles, ws),
    n(o.items)
  ] }, i));
  return !e || e.length === 0 ? null : /* @__PURE__ */ a("div", { className: Os({ size: r }), children: s() });
};
var Be = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.TABLE = "table", e))(Be || {}), zs = "_8bc35b0";
const Ms = ({ children: e, placement: r = "right-start", layerOffset: t, defaultOpen: A = !1, ...n }) => {
  const [s, o] = X(A), i = F(null), { refs: c, floatingStyles: l, context: d } = or({
    open: s,
    onOpenChange: o,
    placement: r,
    middleware: [
      lr(14 / 2 + 8),
      // 14 is the width of the arrow and eight is the offset from the edge of the tooltip
      ir(),
      dr(),
      cr({ element: i })
    ],
    whileElementsMounted: pr
  }), p = ur(d, {
    move: !0,
    handleClose: mr()
  }), u = hr(d), m = vr(d, { role: "tooltip" }), { getReferenceProps: v, getFloatingProps: y } = gr([p, u, m]), N = () => {
    switch (n.variant) {
      case Be.TABLE:
        return /* @__PURE__ */ a(xs, { ...n });
      case Be.DEFAULT:
      default:
        return /* @__PURE__ */ a(Hs, { ...n, arrowRef: i, context: d });
    }
  };
  return /* @__PURE__ */ b(ma, { children: [
    /* @__PURE__ */ a("span", { ref: c.setReference, ...v(), children: e }),
    s && /* @__PURE__ */ a(
      "div",
      {
        className: zs,
        ref: c.setFloating,
        style: { ...V({ [Te]: typeof t == "number" ? String(t) : null }), ...l },
        ...y(),
        ...n,
        "data-testid": "sparta-tooltip",
        children: N()
      }
    )
  ] });
};
var Ws = "fiqf00", da = "fiqf01", Ps = "fiqf02", Xs = "fiqf03";
const ca = ({ onClick: e, tooltip: r, ...t }) => {
  let A;
  if ("icon" in t) {
    const { icon: n } = t;
    A = /* @__PURE__ */ a(T, { ...n, height: n.height ?? 15, width: n.width ?? 15 });
  } else {
    const { text: n, styles: s } = t;
    A = /* @__PURE__ */ a("span", { className: Xs, style: s, children: n });
  }
  return r && (A = /* @__PURE__ */ a(Ms, { ...r, children: A })), e && (A = /* @__PURE__ */ a(le, { className: Ps, onClick: e, children: A })), A;
}, pa = ({ leftActions: e = [], rightActions: r = [] }) => /* @__PURE__ */ b("div", { className: Ws, "data-testid": "table-column-toolbar", children: [
  /* @__PURE__ */ a("div", { className: da, children: e.map((t, A) => /* @__PURE__ */ a(ca, { ...t }, t.id || A)) }),
  /* @__PURE__ */ a("div", { className: da, children: r.map((t, A) => /* @__PURE__ */ a(ca, { ...t }, t.id || A)) })
] }), Fs = ({
  column: e,
  maximumDepth: r,
  depth: t,
  isLastHeaderOfRow: A,
  isOverlay: n,
  nonHiddenColumnsCount: s,
  rootKey: o = e.key,
  totalColumnsCount: i
}) => {
  const {
    state: { colorVariant: c, isPivotal: l, headerPaddingSize: d, correctionFactorValue: p, verticalGrid: u, columns: m, headerSizeVariant: v },
    actions: { handleHoverOverCellMouseEnter: y, handleHoverOverCellMouseLeave: N, isCellVerticallyHovered: f }
  } = ee(), { isColumnSortable: g } = Xa(), {
    label: C,
    sublabel: k,
    isHeader: E,
    textAlign: H,
    hasBorderRight: Q = !0,
    borderBottom: z,
    key: I,
    minWidth: S,
    minHeight: D,
    maxWidth: L,
    hidden: R,
    toolbar: B
  } = e || {}, W = We(l ?? !1, E, I), { paddingTop: ae, paddingRight: P, paddingBottom: te, paddingLeft: J } = Ta(
    H ?? "center",
    d,
    p
  ), q = Za(e), x = e.columns ? 1 : r - t + 1, Ae = Y(
    On,
    E ? za : "",
    he(u) || Q && !A ? "" : un,
    f(I) ? Pe({ colorVariant: c }) : ""
  ), K = m.some((de) => !!de.indicator) && t === 1, ve = () => V({
    [Cn]: H,
    [fn]: D ? `${D}px` : void 0,
    [kn]: S,
    [En]: L,
    [Rn]: z?.color,
    [bn]: `${ae}px ${P}px ${te}px ${J}px`,
    [yn]: K ? "10px" : "0px",
    [Sn]: K ? "top" : "middle"
  }), Se = () => V({
    [In]: f(I) ? e.indicator?.hoverColor : e.indicator?.color
  });
  if (R) return null;
  B && t !== 1 && qe()?.error(
    "Hey, developer, you are attempting to use a toolbar on a column beyond the first level. This won't work. Here you have an example: http://storybook.staging.sparta.zone/index.html?path=/story/atoms-table--with-toolbar-actions"
  );
  const ie = g(o) && !n && !E, Xe = () => {
    if (t !== 1) return null;
    if (n) return /* @__PURE__ */ a(pa, {});
    if (B || m.some((de) => !!de.toolbar) || ie) {
      const de = [...ie ? [{ icon: { type: h.DRAG, height: 10, width: 6.5 } }] : [], ...B?.leftActions || []];
      return /* @__PURE__ */ a(pa, { ...B, leftActions: de });
    }
    return null;
  };
  return /* @__PURE__ */ a(Fa, { id: I, isDraggable: ie, isDroppable: ie, refHandler: W, rootKey: o, type: "column", children: /* @__PURE__ */ b(
    "th",
    {
      className: Ae,
      colSpan: s === 1 ? i : q,
      id: I,
      onMouseEnter: () => y(e?.isHeader, I, null),
      onMouseLeave: N,
      ref: W,
      rowSpan: x,
      style: ve(),
      children: [
        K && /* @__PURE__ */ a(
          "div",
          {
            className: Ln,
            "data-indicator-code": e.indicator?.code ?? "",
            "data-testid": "header-indicator",
            style: Se()
          }
        ),
        /* @__PURE__ */ b("div", { className: Qn, "data-testid": "header-cell-wrapper", children: [
          Xe(),
          (C || k) && /* @__PURE__ */ b("div", { className: Vn, children: [
            /* @__PURE__ */ a("span", { className: Bn({ sizeVariant: v }), "data-testid": "header-label", children: C }),
            k && /* @__PURE__ */ a("span", { className: Hn, "data-testid": "header-sublabel", children: k })
          ] })
        ] })
      ]
    }
  ) });
}, Zs = ({ row: e, maximumDepth: r, index: t }) => {
  const {
    state: { leftColumnsToAddInHeader: A, isPivotal: n, columns: s }
  } = ee(), o = t < r && !!A && A > 0, i = (p) => t === 0 ? s[0] : t < r - 1 ? i(p?.[0]?.columns) : s[0]?.columns?.[0];
  let c;
  o && (c = i(s)?.borderBottom?.color);
  const l = () => V({
    [Nn]: c
  }), d = Y(Dn, n ? ms : "");
  return /* @__PURE__ */ b("tr", { children: [
    o && /* @__PURE__ */ a("td", { className: d, colSpan: A, rowSpan: 1, style: l() }),
    e
  ] });
}, ua = ({ columns: e, isOverlay: r = !1, style: t }) => {
  const A = ke(() => ja(e), [e]), {
    state: { isPivotal: n, leftColumnsToAddInHeader: s }
  } = ee(), o = e[e.length - 1], i = ke(() => e.filter((u) => !u.hidden), [e.length]);
  if (s === void 0) return null;
  const c = (u) => u.reduce((m, v) => v.hidden ? m : m + (v.columns ? c(v.columns) : 1), 0), l = (u, m, v) => u.map((y) => {
    const N = m > 1 ? !!o.columns?.find((g) => g.key === y.key) : !0, f = i.length === 1 ? !0 : u.indexOf(y) === u.length - 1;
    return /* @__PURE__ */ a(
      Fs,
      {
        column: y,
        depth: m,
        isLastHeaderOfRow: f && N,
        isOverlay: r,
        maximumDepth: A,
        nonHiddenColumnsCount: c(e),
        rootKey: v,
        totalColumnsCount: e.length
      },
      y.key
    );
  }), d = (u, m = 1, v) => {
    const y = l(u, m, v), f = u.flatMap((g) => g.columns ? [d(g.columns, m + 1, v || g.key)] : []).reduce((g, C) => (C.forEach((k, E) => {
      g[E] = g[E] ? [...g[E], ...k] : k;
    }), g), []);
    return [y, ...f];
  }, p = d(e);
  return /* @__PURE__ */ a("thead", { className: Y(gn, n && wn), style: t, children: p.map((u, m) => /* @__PURE__ */ a(Zs, { index: m, maximumDepth: A, row: u }, m)) });
}, Ro = ({
  columns: e,
  rows: r,
  onCellClick: t,
  dataTestId: A,
  isInteractive: n = !1,
  isPivotal: s = !1,
  numBodies: o = 1,
  isHoverable: i = !1,
  colorVariant: c = Va.STANDARD,
  headerSizeVariant: l = $.STANDARD,
  bodySizeVariant: d = $.STANDARD,
  correctionFactorValue: p = 1,
  selectedCellId: u,
  onSortColumns: m,
  onSortRows: v,
  customCellComponents: y,
  horizontalGrid: N = { color: oa },
  verticalGrid: f = { color: oa },
  initialOpenRows: g,
  handleNestedRowsOpening: C
}) => {
  if (!e || e.length === 0 || !r || r.length === 0)
    return qe()?.error("No columns or rows provided"), null;
  const k = Me(e);
  return /* @__PURE__ */ a(
    pn,
    {
      bodySizeVariant: d,
      colorVariant: c,
      columns: e,
      correctionFactorValue: p,
      customCellComponents: y,
      handleNestedRowsOpening: C,
      headerSizeVariant: l,
      horizontalGrid: N,
      initialOpenRows: g,
      isHoverable: i,
      isInteractive: n,
      isPivotal: s,
      onCellClick: t,
      rows: r,
      selectedCellId: u,
      verticalGrid: f,
      children: /* @__PURE__ */ a(Es, { ColumnOverlay: ua, RowOverlay: ia, columns: e, onSortColumns: m, onSortRows: v, rows: r, children: /* @__PURE__ */ b(
        "table",
        {
          className: mn({
            colorVariant: c
          }),
          "data-testid": A ?? "sparta-table",
          children: [
            /* @__PURE__ */ a(ua, { columns: e }),
            /* @__PURE__ */ a(ia, { columnKeys: k, numBodies: o, rows: r })
          ]
        }
      ) })
    }
  );
};
export {
  Na as ActionButtonAlignMenu,
  Tt as ActionButtonMenu,
  Ra as ActionButtonMenuColorVariant,
  so as Badge,
  xt as BadgeVariant,
  le as BaseButton,
  kr as Breakpoint,
  ht as Button,
  ba as ButtonColorVariant,
  U as ButtonSize,
  ne as ButtonStatus,
  ct as ButtonVariant,
  we as COLORS,
  co as Carousel,
  Ha as CarouselItem,
  po as Chart,
  EA as ChartLabel,
  ho as ChartLabels,
  Jt as ChartType,
  O as ColorGroup,
  yA as DotsLoader,
  T as Icon,
  ko as IconSkeleton,
  h as IconType,
  to as LAYERS,
  vo as LabelSection,
  bA as LabelSizeType,
  G as Layer,
  go as LoadingBox,
  wa as LoadingBoxVariant,
  Qt as Menu,
  ce as MenuClickType,
  Le as MenuItemStatus,
  se as MenuPlacement,
  ue as MenuSize,
  Ee as MenuVariant,
  Co as MessageBox,
  La as MessageBoxType,
  fo as OverlayMessage,
  be as OverlayMessageSize,
  ao as SpartaThemeProvider,
  Ea as Spinner,
  uo as Switch,
  Eo as SwitchSkeleton,
  Re as SwitchVariant,
  en as Tab,
  Ro as Table,
  Va as TableColor,
  me as TableIconPosition,
  $ as TableSize,
  bo as TableSkeleton,
  pe as TableSkeletonVariant,
  Ua as TableTooltipSize,
  Io as Tabs,
  yo as TabsSkeleton,
  Ne as TabsVariant,
  xe as TextSkeleton,
  Oa as ToggleTabs,
  Eo as ToggleTabsSkeleton,
  Re as ToggleTabsVariant,
  Ms as Tooltip,
  Be as TooltipVariant,
  ge as TypographySize,
  Cr as TypographyType,
  fr as TypographyWeight,
  mo as Widget,
  fe as WidgetSlotType,
  Pt as arrayMove,
  Ta as calculateCellPadding,
  Mt as deriveElementKey,
  qe as devConsole,
  ln as findCellColumnKey,
  ze as findColumnHierarchy,
  on as findGroupHierarchy,
  oo as formatPascalToCamelCase,
  lo as formatToKebabCase,
  ta as getBasePadding,
  Me as getColumnsFlatKeys,
  qa as getFirstRowFromRowGroup,
  he as hasGrid,
  dn as isCellInHoveredColumn,
  oe as isRowGroup,
  zt as isValidReactKey,
  vt as layer,
  Te as layerOffsetVar,
  Ao as shadow,
  no as sprinkles,
  Z as theme,
  Wt as throttle,
  io as typedKeys,
  br as useKeyPress,
  Sa as useMemoizedCb,
  fa as useOnClickAway,
  Da as useResizeObserver,
  ee as useTableContext,
  ro as useTheme,
  Xt as useThrottledCb
};
//# sourceMappingURL=index.es.js.map
